{
  "app.name": "الموقع",
  "sidebar.home": "الرئيسيه",
  "sidebar.settings": "الاعدادات",
  "sidebar.notifications": "اشعارات المستخدمين",
  "sidebar.peopleAndAccess": "الأشخاص والصلاحيات",
  "sidebar.teamMembers": "حسابات الموظفين",
  "sidebar.websiteAccounts": "حسابات الموقع",
  "sidebar.rolesPermissions": "الأدوار والصلاحيات",
  "sidebar.generalCodes": "الاكواد العامه",
  "sidebar.generalCodes.payment": "طرق الدفع",
  "sidebar.generalCodes.orderType": "نوع الطلب",
  "sidebar.generalCodes.pos": "نقاط البيع",
  "sidebar.products": "المنتجات",
  "sidebar.products.categories": "التصنيفات",
  "sidebar.products.list": "المنتجات",
  "sidebar.products.priceRules": "قواعد الأسعار",
  "sidebar.products.promotions": "العروض الترويجية",
  "sidebar.products.tags": "الوسوم",
  "sidebar.products.testimonials": "آراء العملاء",
  "sidebar.customers": "العملاء",
  "sidebar.websiteUsers": "مستخدمو الموقع",
  "sidebar.salesSessions": "جلسات البيع",
  "sidebar.orderSearch": "بحث الطلبات",
  "sidebar.commerce.promotions": "العروض الترويجية",
  "sidebar.returns": "المرتجعات",
  "sidebar.returns.list": "قائمة المرتجعات",
  "sidebar.returns.add": "اضافة مرتجع",
  "sidebar.inventory": "الجرد",
  "sidebar.reports": "التقارير",
  "header.search": "بحث في نقاط البيع",
  "header.notifications": "الاشعارات",
  "header.logout": "تسجيل الخروج",
  "header.language": "اللغة",
  "header.openMenu": "فتح القائمة",
  "header.sidebarNav": "القائمة الجانبية",
  "header.navLinks": "روابط التنقل",
  "header.mainNav": "التنقل الرئيسي",
  "header.searchSystem": "بحث في النظام",
  "auth.login": "تسجيل الدخول",
  "auth.register": "إنشاء حساب",
  "auth.email": "البريد الإلكتروني",
  "auth.password": "كلمة المرور",
  "auth.companyName": "اسم الشركة",
  "auth.sectorType": "نوع القطاع",
  "auth.phone": "رقم الهاتف",
  "auth.address": "العنوان",
  "auth.taxNumber": "الرقم الضريبي",
  "auth.currency": "العملة",
  "auth.language": "اللغة",
  "auth.logo": "شعار الشركة",
  "auth.theme": "ألوان النظام",
  "auth.registerCompany": "تسجيل شركة جديدة",
  "auth.loginCompany": "دخول الشركة",
  "auth.loginUser": "دخول مستخدم",
  "auth.userLoginHint": "دخول الموظفين إلى لوحة التحكم. عملاء المتجر يسجّلون الدخول من الموقع.",
  "auth.dashboardPublicBlocked": "حسابات العملاء لا يمكنها دخول لوحة التحكم. استخدم تسجيل دخول الموقع.",
  "auth.haveAccount": "لديك حساب بالفعل؟",
  "auth.noAccount": "ليس لديك حساب؟",
  "auth.confirmPassword": "تأكيد كلمة المرور",
  "auth.themePreview": "معاينة اللون",
  "auth.companyInfo": "معلومات الشركة",
  "auth.security": "الأمان",
  "auth.otpTitle": "تحقق من بريدك الإلكتروني",
  "auth.otpSubtitle": "أدخل الرمز الذي أرسلناه إلى بريدك الإلكتروني.",
  "auth.forgotTitle": "إعادة تعيين كلمة المرور",
  "auth.forgotSubtitle": "سنرسل رمز إعادة التعيين إلى بريدك الإلكتروني.",
  "auth.resetTitle": "تعيين كلمة مرور جديدة",
  "auth.resetSubtitle": "أدخل الرمز من بريدك واختر كلمة مرور جديدة.",
  "auth.otpCode": "رمز التحقق",
  "auth.verifyCta": "تحقق",
  "auth.resendCta": "إعادة إرسال الرمز",
  "auth.resendWait": "أعد الإرسال خلال {{seconds}} ث",
  "auth.verifyNow": "تحقق الآن",
  "auth.forgotPassword": "نسيت كلمة المرور؟",
  "auth.sendResetCta": "إرسال رمز إعادة التعيين",
  "auth.resetCta": "إعادة تعيين كلمة المرور",
  "auth.newPassword": "كلمة المرور الجديدة",
  "auth.passwordMismatch": "كلمتا المرور غير متطابقتين.",
  "auth.backToLogin": "العودة لتسجيل الدخول",
  "auth.otpInvalid": "الرمز غير صالح أو منتهٍ.",
  "auth.otpExpired": "انتهت صلاحية الرمز. اطلب رمزاً جديداً.",
  "auth.otpBlocked": "التحقق متوقف مؤقتاً. حاول لاحقاً.",
  "auth.otpResendCooldown": "يرجى الانتظار قبل طلب رمز جديد.",
  "auth.otpMaxAttempts": "محاولات غير صحيحة كثيرة. حاول لاحقاً.",
  "auth.otpMaxResends": "تم طلب رموز كثيرة. حاول لاحقاً.",
  "auth.emailNotVerified": "يرجى التحقق من بريدك الإلكتروني قبل تسجيل الدخول.",
  "auth.emailDeliveryFailed": "تعذر إرسال البريد الإلكتروني. حاول مرة أخرى.",
  "auth.resetFailed": "تعذر إعادة تعيين كلمة المرور. حاول مرة أخرى.",
  "theme.primary": "اللون الرئيسي",
  "theme.secondary": "اللون الثانوي",
  "theme.softSurface": "السطح الناعم",
  "theme.pageBackground": "خلفية الصفحة",
  "theme.foreground": "لون النص",
  "theme.accent": "لون التمييز",
  "theme.onBrand": "النص فوق لون العلامة",
  "theme.editor.title": "ألوان العلامة التجارية",
  "theme.editor.subtitle": "هذه الألوان السبعة هي نظام العلامة المشترك للموقع ولوحة التحكم. الوضع الفاتح/الداكن يغيّر أسطح التطبيق فقط (البطاقات، الحدود، خلفية المحتوى) — ألوان العلامة تبقى كما هي.",
  "theme.editor.systemTitle": "كيف يعمل نظام الألوان",
  "theme.editor.systemBody": "استخدم primary لخلفيات العلامة (الشريط الجانبي، شريط التنقل، الأزرار الرئيسية). استخدم onBrand للنصوص والأيقونات فوق هذه الخلفيات — عادةً أبيض. استخدم foreground لنص المحتوى على خلفية الصفحة. Accent للتمييز والروابط والشارات.",
  "theme.editor.chromeAdvice": "التوصية: لا تضف ألواناً منفصلة للشريط الجانبي أو شريط التنقل. أبقِ الاثنين على primary + onBrand ليبقى الموقع ولوحة التحكم متناسقين وسهلَي الصيانة.",
  "theme.editor.hexError": "أدخل لوناً بصيغة #RRGGBB.",
  "theme.editor.reset": "إعادة الألوان الافتراضية",
  "theme.editor.applyExample": "تطبيق مثال الموضة",
  "theme.editor.saving": "جارٍ الحفظ…",
  "theme.editor.saved": "تم حفظ السمة.",
  "theme.editor.saveError": "تعذر حفظ السمة.",
  "theme.editor.dashboardPreview": "معاينة لوحة التحكم",
  "theme.editor.storefrontPreview": "معاينة الموقع",
  "theme.editor.chromeLabel": "شريط التنقل / الشريط الجانبي",
  "theme.editor.previewHeading": "مصمم لعملائك",
  "theme.editor.previewBody": "خلفية الصفحة والأسطح الناعمة ولون النص تشكّل تجربة القراءة في المتجر.",
  "theme.editor.previewAction": "استكشف",
  "theme.editor.previewModeNote": "مناطق المحتوى في لوحة التحكم تتبع الوضع الفاتح/الداكن. إطار العلامة (شريط التنقل والشريط الجانبي والأزرار الرئيسية) يستخدم دائماً primary + onBrand.",
  "theme.editor.websiteUsage": "الموقع",
  "theme.editor.dashboardUsage": "لوحة التحكم",
  "theme.editor.activeHint": "أنت تعدّل {{color}}. تظهر التغييرات مباشرة حتى تحفظ أو تلغي.",
  "theme.guide.primary.summary": "لون العلامة الأساسي — أقوى إشارة بصرية للعلامة.",
  "theme.guide.primary.website": "خلفية شريط تنقل الموقع، الأزرار الرئيسية، والتمييزات المهمة.",
  "theme.guide.primary.dashboard": "خلفية شريط التنقل والشريط الجانبي، أزرار الإجراءات الرئيسية، وحلقات التركيز.",
  "theme.guide.secondary.summary": "لون علامة داعم أعمق للواجهات المتدرجة.",
  "theme.guide.secondary.website": "كتل ثانوية وأسطح تسويقية أعمق.",
  "theme.guide.secondary.dashboard": "لوحات داعمة وتمييزات كثيفة (وليس خلفية الشريط الجانبي الرئيسية).",
  "theme.guide.softSurface.summary": "أسطح ملونة ناعمة خلف المحتوى.",
  "theme.guide.softSurface.website": "بطاقات ناعمة وشرائح وخلفيات أقسام خفيفة في المتجر.",
  "theme.guide.softSurface.dashboard": "خلفيات لوحات خفيفة وأسطح قوائم ناعمة في الوضع الفاتح.",
  "theme.guide.pageBackground.summary": "خلفية الصفحة الافتراضية خلف المحتوى.",
  "theme.guide.pageBackground.website": "خلفية صفحات المتجر (فاتحة دائماً حسب العلامة).",
  "theme.guide.pageBackground.dashboard": "خلفية المحتوى في الوضع الفاتح؛ الوضع الداكن يستبدلها بسطح محايد داكن.",
  "theme.guide.foreground.summary": "النص الأساسي على أسطح الصفحة الفاتحة.",
  "theme.guide.foreground.website": "العناوين ونص المحتوى في المتجر.",
  "theme.guide.foreground.dashboard": "نص المحتوى في الوضع الفاتح (وليس النص على شريط التنقل/الجانبي).",
  "theme.guide.accent.summary": "لون التمييز والتأكيد.",
  "theme.guide.accent.website": "الشارات، الأزرار الثانوية، التمييزات النشطة، والعروض.",
  "theme.guide.accent.dashboard": "إجراءات ثانوية، شارات الحالة، وتمييزات بصرية.",
  "theme.guide.onBrand.summary": "النص والأيقونات فوق خلفيات primary/secondary — اختر تبايناً عالياً (عادةً أبيض).",
  "theme.guide.onBrand.website": "نص روابط شريط التنقل والأيقونات ونص الأزرار الرئيسية.",
  "theme.guide.onBrand.dashboard": "تسميات وأيقونات الشريط الجانبي وشريط التنقل، ونص الأزرار الرئيسية.",
  "theme.features.title": "شارات صفحة المنتج",
  "theme.features.subtitle": "اختر الشارات التي تظهر في صفحة تفاصيل المنتج العامة.",
  "theme.features.freeShipping": "شحن مجاني",
  "theme.features.easyReturns": "إرجاع سهل",
  "theme.features.securePayment": "دفع آمن",
  "theme.features.save": "حفظ الشارات",
  "theme.features.saved": "تم حفظ شارات المتجر.",
  "theme.features.saveError": "تعذر حفظ شارات المتجر.",
  "sector.retail": "تجزئة",
  "sector.restaurant": "مطاعم",
  "sector.pharmacy": "صيدلية",
  "sector.grocery": "بقالة",
  "sector.clothing": "ملابس",
  "sector.electronics": "إلكترونيات",
  "sector.other": "أخرى",
  "common.save": "حفظ",
  "common.cancel": "إلغاء",
  "common.submit": "إرسال",
  "common.loading": "جاري التحميل...",
  "common.select": "اختر",
  "common.error": "حدث خطأ",
  "common.success": "تمت العملية بنجاح",
  "common.required": "هذا الحقل مطلوب",
  "common.optional": "(اختياري)",
  "common.invalidEmail": "البريد الإلكتروني غير صالح",
  "common.minLength": "يجب أن يكون {{min}} أحرف على الأقل",
  "common.characterCountWithMin": "{{count}} حرفاً، الحد الأدنى {{min}}، الحد الأقصى {{max}}",
  "common.uploadLogo": "اسحب الصورة هنا أو انقر للرفع",
  "common.maxFileSize": "الحد الأقصى لحجم الملف 5 ميجابايت",
  "common.dragDrop": "اسحب وأفلت الملف هنا",
  "common.browse": "تصفح",
  "common.active": "نشط",
  "common.inactive": "غير نشط",
  "common.actions": "الإجراءات",
  "common.edit": "تعديل",
  "common.enabled": "مفعّل",
  "common.disabled": "متوقف",
  "common.delete": "حذف",
  "common.create": "إنشاء",
  "common.search": "بحث...",
  "common.noData": "لا توجد بيانات",
  "common.confirm": "تأكيد",
  "common.discard": "تجاهل",
  "common.confirmDelete": "هل أنت متأكد أنك تريد حذف هذا العنصر؟",
  "common.yes": "نعم",
  "common.no": "لا",
  "common.close": "إغلاق",
  "emailSpamHint.title": "لم تصلك الرسالة؟ تحقق من مجلد الرسائل غير المرغوب فيها (Spam)",
  "emailSpamHint.step1": "اذهب إلى بريدك الإلكتروني",
  "emailSpamHint.step2": "افتح القائمة الجانبية",
  "emailSpamHint.step3": "اضغط على Spam (الرسائل غير المرغوب فيها) — ستجد الرسالة هناك",
  "emailSpamHint.step4": "اضغط على \"ليست رسالة مزعجة\" (Not spam) حتى تستمر رسائلنا بالوصول مباشرة إلى بريدك الوارد لاحقًا",
  "common.view": "عرض",
  "common.import": "استيراد",
  "common.export": "تصدير",
  "common.downloadTemplate": "تحميل القالب",
  "common.page": "صفحة",
  "common.of": "من",
  "common.previous": "السابق",
  "common.next": "التالي",
  "datePicker.placeholder": "اختر التاريخ",
  "datePicker.today": "اليوم",
  "datePicker.clear": "مسح",
  "datePicker.previousMonth": "الشهر السابق",
  "datePicker.nextMonth": "الشهر التالي",
  "datePicker.previousYear": "السنة السابقة",
  "datePicker.nextYear": "السنة التالية",
  "datePicker.previousYears": "السنوات السابقة",
  "datePicker.nextYears": "السنوات التالية",
  "datePicker.chooseMonth": "اختر الشهر",
  "datePicker.chooseYear": "اختر السنة",
  "datePicker.jumpToYear": "انتقل إلى سنة",
  "datePicker.showCalendar": "عرض التقويم",
  "datePicker.closeCalendar": "إغلاق التقويم",
  "datePicker.formatHint": "DD/MM/YYYY أو YYYY-MM-DD",
  "datePicker.typeHint": "اكتب التاريخ بصيغة DD/MM/YYYY (15/05/1998) أو YYYY-MM-DD (1998-05-15)",
  "common.sortAsc": "تصاعدي",
  "common.sortDesc": "تنازلي",
  "common.resetFilters": "إعادة تعيين الفلاتر",
  "common.accessDenied": "تم الرفض. ليس لديك الصلاحية المطلوبة.",
  "audit.createdBy": "أنشئ بواسطة",
  "audit.updatedBy": "آخر تحديث بواسطة",
  "audit.createdByCompany": "أنشئ بواسطة الشركة",
  "audit.updatedByCompany": "حُدّث بواسطة الشركة",
  "categories.title": "التصنيفات",
  "categories.create": "إنشاء تصنيف",
  "categories.edit": "تعديل التصنيف",
  "categories.name": "اسم التصنيف",
  "categories.slug": "معرّف الرابط",
  "categories.slugPlaceholder": "womens-clothing",
  "categories.slugInvalid": "استخدم أحرفاً إنجليزية صغيرة وأرقاماً وشرطات فقط.",
  "categories.apiErrors.duplicateSlug": "معرّف الرابط هذا مستخدم لتصنيف آخر أو محجوز من رابط تصنيف سابق. يرجى اختيار معرّف مختلف.",
  "categories.description": "الوصف",
  "categories.status": "الحالة",
  "categories.import": "استيراد من ملف",
  "categories.search": "بحث في التصنيفات...",
  "categories.sortByCreated": "تاريخ الإنشاء",
  "categories.sortByName": "الاسم",
  "categories.noCategories": "لا توجد تصنيفات",
  "categories.confirmDelete": "هل أنت متأكد أنك تريد حذف هذا التصنيف؟",
  "categories.importInstructions": "ارفع ملف Excel (.xlsx) أو CSV (.csv) يحتوي على الأعمدة التالية:",
  "categories.importSuccess": "تم استيراد {{count}} تصنيف بنجاح",
  "categories.importErrors": "{{count}} صفوف بها أخطاء",
  "categories.nameRequired": "اسم التصنيف مطلوب",
  "categories.templateName": "الاسم",
  "categories.templateDescription": "الوصف",
  "categories.exampleBeverages": "مشروبات",
  "categories.exampleFood": "أطعمة",
  "categories.exampleBeveragesDesc": "مشروبات باردة وساخنة",
  "categories.exampleFoodDesc": "أطباق رئيسية وجانبية",
  "categories.subtitle": "قم بإدارة تصنيفات المنتجات الخاصة بك. يمكنك إنشاء، تعديل، حذف، واستيراد التصنيفات بسهولة.",
  "categories.products": "المنتجات",
  "categories.viewProducts": "عرض المنتجات",
  "categories.isActiveLabel": "ظاهر على الموقع",
  "categories.isActiveHint": "عند الإيقاف، يُخفى هذا التصنيف ومنتجاته من الموقع العام.",
  "products.title": "المنتجات",
  "products.subtitle": "إدارة المنتجات. إنشاء وتعديل وتنظيم المنتجات مع المتغيرات والأسعار.",
  "products.create": "إنشاء منتج",
  "products.edit": "تعديل المنتج",
  "products.createPageSubtitle": "أضف بيانات المنتج باللغتين والأسعار والمتغيرات ومعارض الصور.",
  "products.editPageSubtitle": "راجع بيانات المنتج والتوفر والمتغيرات ومعارض الصور.",
  "products.breadcrumb": "التنقل في محرر المنتجات",
  "products.backToProducts": "العودة إلى المنتجات",
  "products.loadError": "تعذّر تحميل المنتج.",
  "products.retry": "إعادة المحاولة",
  "products.informationSection": "معلومات المنتج",
  "products.informationSectionHelp": "أضف المحتوى الظاهر للعملاء باللغتين ونظّم المنتج داخل الكتالوج.",
  "products.sharedImagesSection": "صور المنتج العامة",
  "products.sharedImagesSectionHelp": "تظهر هذه الصور مع جميع الألوان، وتبقى الصورة الأساسية متاحة لواجهات المتجر الحالية.",
  "products.sharedImages": "الصور المشتركة",
  "products.primarySharedImage": "الصورة المشتركة الأساسية",
  "products.sharedImagesHelp": "تظهر الصور المشتركة مع جميع الألوان وتُضاف بعد الصور الخاصة باللون.",
  "products.colorImagesFor": "صور {{color}}",
  "products.colorImagesHelp": "تظهر هذه الصور فقط عند اختيار العميل لهذا اللون، ولن يؤدي اختيار المقاس إلى تغييرها.",
  "products.imageScope": "نطاق الصورة",
  "products.addGalleryImage": "إضافة صورة للمعرض",
  "products.imagesCount": "{{count}} صورة",
  "products.noScopedImages": "لا توجد صور في هذه المجموعة بعد.",
  "products.moveImageEarlier": "نقل الصورة إلى الأمام",
  "products.moveImageLater": "نقل الصورة إلى الخلف",
  "products.variantImageNote": "بعد إضافة متغيرات الألوان، يظهر كل لون محدد في قائمة نطاق الصورة لتتمكن من رفع صور خاصة به. لا يتم تخصيص صور منفصلة للمقاسات.",
  "products.pricingSection": "الأسعار والمخزون",
  "products.pricingSectionHelp": "حدّد رمز التخزين الأساسي والتكلفة والسعر والضريبة والمخزون.",
  "products.variantsSection": "متغيرات المنتج",
  "products.variantsSectionHelp": "أنشئ تركيبات قابلة للشراء. يمكن فقط لخيارات مجموعة اللون امتلاك معرض صور خاص.",
  "products.name": "اسم المنتج",
  "products.slug": "معرّف الرابط (URL Slug)",
  "products.slugPlaceholder": "cotton-shirt",
  "products.slugInvalid": "استخدم أحرفاً إنجليزية صغيرة وأرقاماً وشرطات فقط.",
  "products.slugHelpLabel": "شرح معرّف الرابط",
  "products.slugHelp": "هذا الاسم القصير يظهر في عنوان صفحة المنتج على الموقع، مثل /products/cotton-shirt. يُنشأ تلقائياً عند حفظ منتج جديد. غيّره فقط إذا احتجت عنواناً مختلفاً. بعد التغيير، العنوان القديم يوجّه الزوار إلى هذا المنتج.",
  "products.slugHint": "يظهر في رابط المتجر بالشكل /products/your-slug",
  "products.slugEdit": "تعديل معرّف الرابط",
  "products.slugCancel": "إلغاء تعديل معرّف الرابط",
  "products.description": "الوصف",
  "products.productCode": "كود المنتج",
  "products.category": "التصنيف",
  "products.selectCategory": "اختر التصنيف",
  "products.gender": "الجنس",
  "products.selectGender": "اختر الجنس",
  "products.genderRequired": "الجنس مطلوب",
  "products.genderMale": "رجالي",
  "products.genderFemale": "نسائي",
  "products.genderUnisex": "للجنسين",
  "products.codeType": "نوع كود المنتج",
  "products.codeTypeHelpLabel": "شرح نوع كود المنتج",
  "products.codeTypeHelp": "يحدد كيفية تفسير معرّف المنتج ومسحه. الباركود مناسب لأجهزة المسح في نقاط البيع، ورمز QR يخزن رمزاً ثنائي الأبعاد، والتسلسلي مناسب لرقم فريد أو داخلي. اختر النوع المطابق للكود المطبوع على المنتج أو المخصص له.",
  "products.selectCodeType": "اختر نوع الكود",
  "products.barcodeType": "باركود",
  "products.qrType": "رمز QR",
  "products.serialType": "تسلسلي",
  "products.sku": "رمز التخزين",
  "products.skuHelpLabel": "شرح رمز التخزين SKU",
  "products.skuHelp": "رمز SKU هو معرّف داخلي للمخزون يُستخدم لتمييز المنتج والبحث عنه وتتبع كمياته. لا يحتاج العميل عادةً إلى رؤيته.",
  "products.variantSkuHelp": "يعرّف هذا الرمز تركيبة واحدة قابلة للبيع، مثل أسود / كبير، لتتبع مخزونها وسعرها بشكل مستقل.",
  "products.costPrice": "سعر التكلفة",
  "products.salePrice": "سعر البيع",
  "products.taxPercentage": "الضريبة %",
  "products.status": "الحالة",
  "products.hasVariants": "هذا المنتج يحتوي على متغيرات",
  "products.hasVariantsHelp": "فعّل هذا الخيار عندما يُباع المنتج بخيارات مثل الألوان أو المقاسات.",
  "products.variants": "المتغيرات",
  "products.variant": "متغير",
  "products.addVariant": "إضافة متغير",
  "products.saveVariant": "حفظ المتغير",
  "products.unsavedVariants": "احفظ كل متغير مفتوح قبل حفظ المنتج.",
  "products.variantValidationTitle": "تعذر حفظ المتغير رقم {{number}}",
  "products.variantValidationHelp": "راجع الحقول المحددة داخل هذا المتغير وأكمل القيم المطلوبة.",
  "products.variantGroupRequired": "اختر المجموعة في صف الخيار رقم {{row}}.",
  "products.variantOptionRequired": "اختر الخيار في صف الخيار رقم {{row}}.",
  "products.variantCostPriceInvalid": "أدخل سعر تكلفة صحيحاً يساوي صفراً أو أكثر.",
  "products.variantSalePriceInvalid": "أدخل سعر بيع صحيحاً يساوي صفراً أو أكثر.",
  "products.variantStockQtyInvalid": "أدخل كمية مخزون صحيحة وكاملة تساوي صفراً أو أكثر.",
  "products.variantAttributes": "السمات والقيم",
  "products.variantAttributesHelp": "اختر كل سمة مرة واحدة، ثم اختر جميع القيم المباعة. سيتم إنشاء كل التركيبات مع الاحتفاظ بالتعديلات الحالية.",
  "products.addVariantGroup": "إضافة سمة",
  "products.variantValues": "القيم",
  "products.selectVariantValues": "اختر قيمة واحدة أو أكثر",
  "products.combination": "التركيبة",
  "products.variantsRequired": "اختر سمة وقيمة واحدة على الأقل.",
  "products.duplicateVariantGroup": "لا يمكن تكرار السمة داخل المتغير.",
  "products.duplicateVariantOption": "لا يمكن تكرار قيمة الخيار داخل المتغير.",
  "products.duplicateVariantCombination": "يجب أن تكون كل تركيبة متغير فريدة.",
  "products.duplicateSku": "يجب أن تكون رموز تخزين المنتج والمتغيرات فريدة.",
  "products.apiErrors.duplicateProductCode": "كود المنتج مستخدم مسبقاً.",
  "products.apiErrors.duplicateSlug": "معرّف الرابط هذا مستخدم لمنتج آخر أو محجوز من رابط منتج سابق. يرجى اختيار معرّف مختلف.",
  "products.apiErrors.duplicateSku": "رمز التخزين مستخدم مسبقاً.",
  "products.apiErrors.duplicateVariantCombination": "يوجد متغير بهذه التركيبة مسبقاً.",
  "products.apiErrors.duplicateVariantGroup": "يجب أن يحتوي كل متغير على قيمة واحدة فقط لكل سمة.",
  "products.apiErrors.invalidVariantOptions": "راجع سمات المتغير وقيمه.",
  "products.variantOptions": "الخيارات",
  "products.addOption": "إضافة خيار",
  "products.groupName": "المجموعة",
  "products.groupNamePlaceholder": "مثال: الحجم",
  "products.optionName": "الخيار",
  "products.optionNamePlaceholder": "مثال: كبير",
  "products.search": "بحث في المنتجات...",
  "products.sortByCreated": "تاريخ الإنشاء",
  "products.sortByName": "الاسم",
  "products.sortByPrice": "السعر",
  "products.allCategories": "كل التصنيفات",
  "products.noProducts": "لا توجد منتجات",
  "products.nameRequired": "اسم المنتج مطلوب",
  "products.descriptionRequired": "الوصف باللغة الإنجليزية مطلوب",
  "products.descriptionArRequired": "الوصف باللغة العربية مطلوب",
  "products.productCodeRequired": "كود المنتج مطلوب",
  "products.categoryRequired": "التصنيف مطلوب",
  "products.costPriceRequired": "سعر التكلفة مطلوب",
  "products.salePriceRequired": "سعر البيع مطلوب",
  "products.confirmDeleteTitle": "حذف المنتج",
  "products.confirmDelete": "هل أنت متأكد أنك تريد حذف هذا المنتج؟ لا يمكن التراجع عن هذا الإجراء.",
  "priceRules.title": "قواعد الأسعار",
  "priceRules.subtitle": "إدارة العروض والخصومات لهذا المنتج.",
  "priceRules.managementTitle": "قواعد الأسعار",
  "priceRules.managementSubtitle": "تطبّق قواعد الأسعار خصومات مجدولة أو مشروطة على كل المنتجات أو منتجات محددة أو منتج واحد أو متغير محدد. يتم تقييم القواعد النشطة المطابقة حسب الأولوية، لذلك تتحكم القاعدة الأعلى أولوية في السعر النهائي للعميل.",
  "priceRules.search": "بحث في قواعد الأسعار...",
  "priceRules.allProducts": "كل المنتجات",
  "priceRules.specificProducts": "منتجات محددة",
  "priceRules.couponScope": "ينطبق الكوبون على",
  "priceRules.ruleScope": "تنطبق القاعدة على",
  "priceRules.scopeSpecificProduct": "منتج محدد",
  "priceRules.ruleScopeAllHint": "تنطبق هذه القاعدة على كل المنتجات المؤهلة في المتجر.",
  "priceRules.ruleScopeSpecificHint": "تنطبق هذه القاعدة فقط على المنتج المحدد، ويمكن حصرها في أحد متغيراته.",
  "priceRules.couponScopeAll": "كل المنتجات",
  "priceRules.couponScopeSpecific": "منتجات محددة",
  "priceRules.couponProducts": "المنتجات المؤهلة",
  "priceRules.selectCouponProducts": "اختر منتجاً واحداً أو أكثر",
  "priceRules.couponProductsRequired": "اختر منتجاً واحداً على الأقل أو اختر كل المنتجات.",
  "priceRules.couponScopeAllHint": "يمكن للكوبون خصم جميع المنتجات المؤهلة في سلة العميل.",
  "priceRules.couponScopeSpecificHint": "يخصم الكوبون المنتجات المحددة هنا فقط.",
  "priceRules.selectProduct": "اختر منتجاً",
  "priceRules.productRequired": "اختر منتجاً لهذه القاعدة",
  "priceRules.product": "المنتج",
  "priceRules.rule": "القاعدة",
  "priceRules.schedule": "الجدول الزمني",
  "priceRules.variantScope": "نطاق المتغير",
  "priceRules.allVariants": "كل متغيرات المنتج",
  "priceRules.active": "القاعدة مفعّلة",
  "priceRules.activeHint": "تبقى القواعد غير المفعّلة محفوظة دون تطبيقها.",
  "priceRules.create": "إنشاء قاعدة سعر",
  "priceRules.createHint": "حدّد عرضاً للمنتج دون تعديل متغيراته أو معارض صوره.",
  "priceRules.editHint": "حدّث نطاق القاعدة والخصم والجدول والأولوية.",
  "priceRules.newRule": "قاعدة جديدة",
  "priceRules.add": "إضافة قاعدة",
  "priceRules.manage": "إدارة قواعد الأسعار",
  "priceRules.edit": "تعديل القاعدة",
  "priceRules.name": "اسم القاعدة",
  "priceRules.namePlaceholder": "مثال: تخفيضات الصيف",
  "priceRules.nameRequired": "اسم القاعدة مطلوب",
  "priceRules.discountType": "نوع الخصم",
  "priceRules.discountTypeRequired": "نوع الخصم مطلوب",
  "priceRules.selectType": "اختر النوع",
  "priceRules.discountValue": "قيمة الخصم",
  "priceRules.applicationType": "طريقة تطبيق القاعدة",
  "priceRules.automaticLabel": "خصم تلقائي",
  "priceRules.automaticHint": "تُطبّق هذه القاعدة تلقائياً على كل المنتجات أو المنتج المحدد طالما أنها مفعّلة. لا يحتاج العميل إلى رمز كوبون.",
  "priceRules.couponLabel": "كوبون خصم",
  "priceRules.couponHint": "يجب أن يُدخل العميل أحد رموز كوبونات هذه القاعدة عند الدفع للحصول على الخصم.",
  "priceRules.coupons": "رموز الكوبونات",
  "priceRules.couponsHint": "أضف رمزاً واحداً أو أكثر. يستخدم كل رمز في هذه القاعدة نوع الخصم وقيمته المحددين أعلاه.",
  "priceRules.couponCount": "الكوبونات",
  "priceRules.addCoupon": "إضافة كوبون",
  "priceRules.couponCode": "رمز الكوبون",
  "priceRules.couponCodePlaceholder": "مثال: SAVE15",
  "priceRules.couponCodeInvalid": "استخدم من 3 إلى 40 حرفاً إنجليزياً كبيراً أو رقماً أو شرطة سفلية أو شرطة، من دون مسافات.",
  "priceRules.couponCodeDuplicate": "يجب أن يكون كل رمز كوبون في هذه القاعدة مختلفاً.",
  "priceRules.couponRequired": "أضف رمز كوبون واحداً على الأقل.",
  "priceRules.automaticCouponsNotAllowed": "لا يمكن أن يتضمن الخصم التلقائي رموز كوبونات.",
  "priceRules.invalidAutomaticScope": "اختر كل المنتجات أو منتجاً محدداً واحداً للخصم التلقائي.",
  "priceRules.invalidCouponScope": "اختر كل المنتجات أو منتجات محددة لخصم الكوبون.",
  "priceRules.percentageLimit": "لا يمكن أن تزيد نسبة الخصم عن 100٪.",
  "priceRules.saveFailed": "تعذر حفظ قاعدة التسعير. راجع الحقول المطلوبة ثم حاول مرة أخرى.",
  "priceRules.usageLimit": "إجمالي حد الاستخدام",
  "priceRules.perCustomerLimit": "مرات الاستخدام لكل عميل",
  "priceRules.couponExpiresAt": "انتهاء الكوبون",
  "priceRules.couponActive": "الكوبون مفعّل",
  "priceRules.optionalPositiveInteger": "أدخل عدداً صحيحاً أكبر من صفر، أو اترك الحقل فارغاً.",
  "priceRules.unlimited": "غير محدود",
  "priceRules.percentage": "نسبة مئوية",
  "priceRules.fixedAmount": "مبلغ ثابت",
  "priceRules.fixedPrice": "سعر ثابت",
  "priceRules.startsAt": "تاريخ البدء",
  "priceRules.endsAt": "تاريخ الانتهاء",
  "priceRules.customerSegment": "شريحة العملاء",
  "priceRules.customerSegmentPlaceholder": "مثال: VIP",
  "priceRules.customerSegmentHint": "اختياري. مثال: اكتب «VIP» لتطابق القاعدة العملاء الذين تحددهم أداة الأسعار الإدارية كعملاء VIP فقط. لا يغيّر هذا الحقل الأسعار في الموقع أو السلة أو الدفع حالياً. اتركه فارغاً لتتاح القاعدة لجميع العملاء.",
  "priceRules.minQuantity": "الحد الأدنى للكمية",
  "priceRules.minQty": "حد أدنى",
  "priceRules.priority": "الأولوية",
  "priceRules.noRules": "لا توجد قواعد أسعار بعد",
  "priceRules.noRulesHint": "أضف قاعدة لإعداد العروض أو التسعير الخاص.",
  "priceRules.confirmDeleteTitle": "حذف قاعدة السعر",
  "priceRules.confirmDelete": "هل أنت متأكد أنك تريد حذف قاعدة السعر هذه؟",
  "priceRules.status.active": "نشطة",
  "priceRules.status.scheduled": "مجدولة",
  "priceRules.status.expired": "منتهية",
  "priceRules.status.inactive": "غير مفعّلة",
  "priceRules.helpButton": "كيف تعمل هذه القاعدة؟",
  "priceRules.helpIntro": "استخدم القاعدة لتغيير سعر منتج واحد أو متغير محدد. يتم تقييمها عند حلّ السعر ولا تستبدل سعر بيع المنتج المحفوظ بشكل دائم.",
  "priceRules.helpActiveTitle": "القواعد المفعّلة والنشطة",
  "priceRules.helpActiveBody": "يمكن تطبيق القاعدة المفعّلة فقط ضمن تاريخَي البداية والنهاية. تبقى القاعدة غير المفعّلة محفوظة لكنها لا تُطبّق. تلتزم القواعد الجديدة بمفتاح تفعيل القاعدة.",
  "priceRules.helpDiscountTitle": "كيفية تطبيق الخصم",
  "priceRules.helpDiscountBody": "النسبة المئوية تخفض سعر البيع بنسبة محددة، والمبلغ الثابت يطرح مبلغاً من العملة، والسعر النهائي يحدد السعر المحسوب. تُطبّق قاعدة مطابقة واحدة فقط.",
  "priceRules.helpScheduleTitle": "التواريخ والانتهاء",
  "priceRules.helpScheduleBody": "قبل تاريخ البداية تكون القاعدة مجدولة ولا تُطبّق. بعد تاريخ النهاية تنتهي ولا تُطبّق. يُحسب السعر المؤهل التالي تلقائياً، لذلك يعود المنتج إلى سعره العادي أو إلى قاعدة مؤهلة أخرى.",
  "priceRules.helpMinQuantityTitle": "الحد الأدنى للكمية",
  "priceRules.helpMinQuantityBody": "اترك هذا الحقل فارغاً لتطبيق القاعدة على أي كمية. أدخل رقماً لتُطبّق القاعدة فقط عندما يشتري العميل هذا العدد أو أكثر من وحدات المنتج أو المتغير نفسه.",
  "priceRules.helpPriorityTitle": "الأولوية عند تداخل القواعد",
  "priceRules.helpPriorityBody": "تُستخدم الأولوية فقط عندما تطابق عدة قواعد مؤهلة المنتج أو المتغير نفسه. الرقم الأعلى يفوز، و0 هو القيمة الافتراضية. تُطبّق قاعدة واحدة فقط، لذلك لا تتراكم الخصومات.",
  "priceRules.helpCouponTitle": "كوبونات الخصم",
  "priceRules.helpCouponBody": "لا تُطبّق قاعدة الكوبون إلا عندما يُدخل العميل رمزاً صالحاً عند الدفع. يمكنك إتاحتها لكل المنتجات أو اختيار منتج واحد أو عدة منتجات محددة. مثال: قاعدة كوبون بخصم 15٪ ورمز SAVE15 تجعل منتجاً مؤهلاً بسعر 30 ديناراً بسعر 25.50 ديناراً بعد أي خصم تلقائي. ويمكنك أيضاً تحديد إجمالي الاستخدامات، وحد كل عميل، وتاريخ الانتهاء، وحالة تفعيل الرمز.",
  "priceRules.helpPercentageTitle": "خصم بالنسبة المئوية",
  "priceRules.helpPercentageBody": "استخدمه عندما يجب أن يتغير الخصم مع سعر المنتج. مثال: قاعدة خصم 20٪ تجعل منتجاً بسعر 50 ديناراً بسعر 40 ديناراً ما دامت القاعدة مفعّلة.",
  "priceRules.helpFixedAmountTitle": "خصم بمبلغ ثابت",
  "priceRules.helpFixedAmountBody": "استخدمه لطرح المبلغ نفسه من العملة. مثال: قاعدة 5 دنانير تجعل منتجاً بسعر 30 ديناراً بسعر 25 ديناراً ما دامت القاعدة مفعّلة.",
  "priceRules.helpFixedPriceTitle": "سعر نهائي ثابت",
  "priceRules.helpFixedPriceBody": "استخدمه لتحديد السعر الدقيق للعميل. مثال: قاعدة سعر نهائي بقيمة 25 ديناراً تجعل منتجاً بسعر 30 ديناراً بسعر 25 ديناراً ما دامت القاعدة مفعّلة.",
  "priceRules.helpAutomaticTitle": "قواعد الأسعار التلقائية",
  "priceRules.helpAutomaticBody": "تُطبّق القواعد التلقائية دون أي إجراء من العميل. يمكنك استهداف كل المنتجات أو منتج محدد، ويمكنك حصر المنتج المحدد في أحد متغيراته. استخدمها للعروض العامة والخصومات المجدولة.",
  "priceRules.helpSegmentTitle": "شرائح العملاء",
  "priceRules.helpSegmentBody": "شريحة العملاء هي تسمية داخلية لتجميع العملاء. مثال: أنشئ قاعدة باسم شريحة العملاء «VIP» وخصم 10٪. عندما تتحقق أداة الأسعار الإدارية من عميل محدد بالاسم المطابق تماماً «VIP»، يمكنها إرجاع سعر بخصم 10٪. العميل المحدد باسم «Regular» لا يطابق القاعدة. لا يستخدم الموقع أو السلة أو الدفع الشرائح حالياً، لذلك لن تغيّر هذه القاعدة السعر المعروض فيها. اترك الحقل فارغاً لخصم يشمل الموقع كله.",
  "priceRules.helpDeleteTitle": "حذف القاعدة",
  "priceRules.helpDeleteBody": "يمكن حذف القاعدة حتى إن كانت مرتبطة بمنتج. تُزال فوراً ولا تؤثر في حسابات الأسعار اللاحقة. كما يؤدي حذف المنتج إلى إزالة قواعده المرتبطة.",
  "promotions.title": "العروض الترويجية",
  "promotions.subtitle": "أنشئ عروض اشترِ واحصل وخصومات الإنفاق المجدولة.",
  "promotions.create": "إنشاء عرض",
  "promotions.edit": "تعديل العرض",
  "promotions.search": "بحث في العروض...",
  "promotions.name": "العرض",
  "promotions.nameEn": "الاسم بالإنجليزية",
  "promotions.nameAr": "الاسم بالعربية",
  "promotions.type": "نوع العرض",
  "promotions.priority": "الأولوية",
  "promotions.status": "الحالة",
  "promotions.schedule": "الجدول الزمني",
  "promotions.benefit": "الميزة",
  "promotions.active": "العرض مفعّل",
  "promotions.startsAt": "تاريخ البدء",
  "promotions.endsAt": "تاريخ الانتهاء",
  "promotions.allTypes": "كل الأنواع",
  "promotions.allStatuses": "كل الحالات",
  "promotions.types.BUY_X_GET_Y": "اشترِ س واحصل على ص",
  "promotions.types.SPEND_THRESHOLD_PERCENTAGE": "نسبة خصم حسب حد الإنفاق",
  "promotions.statuses.active": "نشط",
  "promotions.statuses.scheduled": "مجدول",
  "promotions.statuses.expired": "منتهي",
  "promotions.statuses.inactive": "غير مفعّل",
  "promotions.empty": "لا توجد عروض",
  "promotions.qualifiers": "المنتجات المؤهلة",
  "promotions.addQualifier": "إضافة منتج مؤهل",
  "promotions.reward": "منتج المكافأة",
  "promotions.product": "المنتج",
  "promotions.variant": "المتغير المحدد (اختياري)",
  "promotions.selectProduct": "اختر منتجاً",
  "promotions.searchProducts": "ابحث عن منتجات...",
  "promotions.allVariants": "كل المتغيرات",
  "promotions.buyQuantity": "الكمية التي يشتريها العميل",
  "promotions.rewardQuantity": "كمية المكافأة",
  "promotions.maxRewards": "الحد الأقصى للمكافآت في الطلب",
  "promotions.tiers": "شرائح الإنفاق",
  "promotions.tiersHint": "الحد الأدنى مشمول والأقصى غير مشمول. اترك الحد الأقصى للشريحة الأخيرة فارغاً بلا سقف.",
  "promotions.addTier": "إضافة شريحة",
  "promotions.minSubtotal": "الحد الأدنى للمجموع",
  "promotions.maxSubtotal": "الحد الأقصى للمجموع",
  "promotions.discountPercentage": "نسبة الخصم",
  "promotions.summary": "ملخص واضح",
  "promotions.buyGetSummary": "اشترِ {{buy}} واحصل على {{reward}}",
  "promotions.deleteTitle": "حذف العرض",
  "promotions.deleteMessage": "هل أنت متأكد من حذف هذا العرض؟ لا يمكن التراجع عن ذلك.",
  "promotions.errors.nameEn": "الاسم الإنجليزي مطلوب.",
  "promotions.errors.schedule": "يجب أن يكون تاريخ الانتهاء بعد تاريخ البدء.",
  "promotions.errors.buyGet": "اختر كل المنتجات المؤهلة ومنتج المكافأة وأدخل كميات موجبة.",
  "promotions.errors.tiers": "صحح شرائح الإنفاق غير الصالحة أو المتداخلة.",
  "promotions.errors.invalidTier": "أدخل نطاقاً صالحاً ونسبة من 1 إلى 100.",
  "promotions.errors.overlap": "تتداخل هذه الشريحة مع الشريحة السابقة.",
  "promotions.errors.openTierLast": "يمكن أن تكون الشريحة الأخيرة فقط بلا حد أقصى.",
  "promotions.helpButton": "كيف تعمل هذه القاعدة؟",
  "promotions.helpTitle": "كيف تعمل العروض الترويجية",
  "promotions.helpBasicsTitle": "متى تُطبّق العروض",
  "promotions.helpBasicsBody": "تُقيَّم العروض بناءً على السلة الحالية عند إتمام الدفع. يعيد الخادم التحقق من المنتجات والأسعار والمخزون والجدول الزمني والأهلية، لذلك لا يؤثر تعديل العرض في الطلبات التي تم إنشاؤها مسبقاً.",
  "promotions.helpBuyGetTitle": "اشترِ س واحصل على ص",
  "promotions.helpBuyGetBody": "اختر منتجاً مؤهلاً واحداً أو أكثر أو متغيرات محددة، وحدد الكمية التي يجب أن يشتريها العميل، ثم اختر منتج أو متغير المكافأة المحدد. تُضاف المكافأة تلقائياً كسطر مجاني غير قابل للتعديل في السلة، لكنها تستخدم المخزون ويُخصم مخزونها عند تأكيد الطلب.",
  "promotions.helpSpendTitle": "حدود الإنفاق",
  "promotions.helpSpendBody": "تُطبّق كل شريحة عندما يصل مجموع السلة المدفوع إلى حدها الأدنى. الحد الأدنى مشمول والحد الأقصى غير مشمول، لذا يجب ألا تتداخل النطاقات. يُحسب الخصم بعد قواعد سعر المنتج التلقائية وقبل الكوبونات والضريبة والتوصيل.",
  "promotions.helpScheduleTitle": "الجدول الزمني وحالة التفعيل",
  "promotions.helpScheduleBody": "العرض غير المفعّل لا يُطبّق أبداً. العرض قبل تاريخ البدء يكون مجدولاً وبعد تاريخ الانتهاء يكون منتهياً. يعيد الخادم التحقق من التواريخ عند الدفع.",
  "promotions.helpPriorityTitle": "الأولوية وتداخل العروض",
  "promotions.helpPriorityBody": "يُطبّق عرض ترويجي تلقائي واحد فقط على السلة. يختار النظام العرض المؤهل الذي يمنح العميل أكبر توفير قبل الضريبة. تُستخدم الأولوية فقط عند تساوي قيمة التوفير؛ الرقم الأعلى يفوز. لا تتراكم العروض الترويجية مع بعضها.",
  "promotions.helpCouponsTitle": "الكوبونات وقواعد الأسعار الأخرى",
  "promotions.helpCouponsBody": "تُطبّق أولاً قواعد أسعار المنتج أو المتغير التلقائية الحالية، ثم أفضل عرض ترويجي واحد للسلة، ثم تُطبّق رموز الكوبونات المؤهلة على السطور المدفوعة المتبقية. لا تتلقى سطور المكافآت المجانية خصم كوبون آخر.",
  "commerce.promotions.free": "مجاني",
  "commerce.promotions.freeGift": "هدية ترويجية مجانية",
  "commerce.promotions.freeGiftFrom": "هدية مجانية من عرض {{name}}",
  "commerce.promotions.managedAutomatically": "أُضيف تلقائياً بواسطة العرض",
  "commerce.promotions.discount": "خصم العرض الترويجي",
  "commerce.promotions.appliedBenefits": "العروض والمزايا المطبقة",
  "commerce.promotions.types.BUY_X_GET_Y": "اشترِ منتجات واحصل على منتج مجاني",
  "commerce.promotions.types.SPEND_THRESHOLD_PERCENTAGE": "خصم حسب حد الإنفاق",
  "commerce.promotions.buyGetExplanation": "احتوت السلة على {{qualifyingQuantity}} منتجاً مؤهلاً وحققت شرط شراء {{buyQuantity}}. حصل العميل على {{rewardQuantity}} منتج مجاني.",
  "commerce.promotions.spendExplanation": "بلغ المجموع المؤهل {{subtotal}} وحقق حد {{minimum}}، فحصل العميل على خصم {{percentage}}٪.",
  "commerce.admin.noStatusTransitions": "الطلب في حالة نهائية ولا يمكن نقله إلى حالة أخرى.",
  "commerce.admin.noPaymentTransitions": "لا يوجد إجراء دفع آخر متاح لحالة الدفع الحالية.",
  "commerce.admin.verifyClickBeforeConfirm": "تحقق من إثبات دفع كليك قبل تأكيد هذا الطلب.",
  "commerce.admin.confirmDeliveredTitle": "تعيين الطلب كمُسلَّم؟",
  "commerce.admin.confirmDeliveredMessage": "سيؤدي ذلك إلى إنهاء التنفيذ وقفل حالة الطلب، ولن يمكن تغييرها بعد ذلك.",
  "commerce.admin.confirmDelivered": "تعيين كمُسلَّم",
  "commerce.admin.confirmPaymentTitle": "تأكيد حالة الدفع؟",
  "commerce.admin.confirmPaymentMessage": "هل تريد تعيين حالة الدفع إلى {{status}}؟ هذا قرار دفع نهائي ولن يمكن تغييره بعد ذلك.",
  "commerce.admin.confirmPayment": "تأكيد حالة الدفع",
  "users.title": "حسابات الموظفين",
  "users.subtitle": "إدارة حسابات الموظفين وحالة الوصول وتعيين الأدوار.",
  "users.create": "إنشاء مستخدم",
  "users.edit": "تعديل المستخدم",
  "users.email": "البريد الإلكتروني",
  "users.password": "كلمة المرور",
  "users.username": "اسم المستخدم",
  "users.firstName": "الاسم الأول",
  "users.lastName": "اسم العائلة",
  "users.role": "الدور",
  "users.selectRole": "اختر الدور",
  "users.status": "الحالة",
  "users.pending": "قيد الانتظار",
  "users.lastLogin": "آخر تسجيل دخول",
  "users.loginCount": "عدد مرات الدخول",
  "users.joinedAt": "تاريخ الانضمام",
  "users.never": "لم يسجل الدخول",
  "users.search": "بحث في المستخدمين...",
  "users.allRoles": "كل الأدوار",
  "users.allStatuses": "كل الحالات",
  "users.sortByCreated": "تاريخ الإنشاء",
  "users.noUsers": "لا يوجد مستخدمون",
  "users.emailRequired": "البريد الإلكتروني مطلوب",
  "users.passwordRequired": "كلمة المرور مطلوبة",
  "users.roleRequired": "الدور مطلوب",
  "users.confirmDeleteTitle": "حذف المستخدم",
  "users.confirmDelete": "هل أنت متأكد أنك تريد حذف هذا المستخدم؟",
  "users.verifyEmailTitle": "تحقق من بريد الموظف",
  "users.verifyEmailHint": "أدخل الرمز المرسل إلى هذا البريد. بعد التحقق سيصل الموظف إلى دعوته.",
  "users.verifyEmailFailed": "تعذر التحقق من هذا البريد. حاول مرة أخرى.",
  "users.verifyCta": "تحقق",
  "users.resendCta": "إعادة إرسال الرمز",
  "users.otpCode": "رمز التحقق",
  "users.resendWait": "أعد الإرسال خلال {{seconds}} ث",
  "roles.title": "الأدوار والصلاحيات",
  "roles.subtitle": "تحديد أدوار الموظفين والصلاحيات الممنوحة لكل دور.",
  "roles.create": "إنشاء دور",
  "roles.edit": "تعديل الدور",
  "roles.name": "اسم الدور",
  "roles.nameEn": "اسم الدور (بالإنجليزية)",
  "roles.nameAr": "اسم الدور (بالعربية)",
  "roles.nameEnPlaceholder": "مثال: Catalog manager",
  "roles.nameArPlaceholder": "مثال: مدير الكتالوج",
  "roles.nameEnRequired": "اسم الدور بالإنجليزية مطلوب",
  "roles.nameArRequired": "اسم الدور بالعربية مطلوب",
  "roles.description": "الوصف",
  "roles.descriptionEn": "الوصف (بالإنجليزية)",
  "roles.descriptionAr": "الوصف (بالعربية)",
  "roles.descriptionEnPlaceholder": "اكتب وصف مسؤوليات الدور بالإنجليزية",
  "roles.descriptionArPlaceholder": "اكتب وصف مسؤوليات هذا الدور",
  "roles.descriptionPairRequired": "يجب إدخال الوصف باللغتين الإنجليزية والعربية",
  "roles.status": "الحالة",
  "roles.permissions": "الصلاحيات",
  "roles.selectPermissions": "اختر الصلاحيات",
  "roles.roleInformation": "معلومات الدور",
  "roles.roleInformationHelp": "أضف اسماً ووصفاً واضحين للدور باللغتين.",
  "roles.permissionAssignment": "تعيين الصلاحيات",
  "roles.permissionAssignmentHelp": "انقر على الصلاحية لنقلها بين القائمتين المتاحة والمُعيّنة.",
  "roles.selectedPermissions": "الصلاحيات المُعيّنة",
  "roles.availablePermissions": "الصلاحيات المتاحة",
  "roles.noSelectedPermissions": "لم يتم تعيين أي صلاحيات بعد.",
  "roles.noAvailablePermissions": "تم تعيين جميع الصلاحيات المطابقة.",
  "roles.searchSelectedPermissions": "بحث في الصلاحيات المُعيّنة...",
  "roles.searchAvailablePermissions": "بحث في الصلاحيات المتاحة...",
  "roles.addPermission": "تعيين الصلاحية",
  "roles.removePermission": "إزالة الصلاحية",
  "roles.removeAllPermissions": "إزالة الكل",
  "roles.permissionGroups.products": "صلاحيات المنتجات",
  "roles.permissionGroups.categories": "صلاحيات التصنيفات",
  "roles.permissionGroups.promotions": "صلاحيات العروض الترويجية",
  "roles.permissionGroups.banners": "صلاحيات اللافتات",
  "roles.permissionGroups.media": "صلاحيات الوسائط",
  "roles.permissionGroups.orders": "صلاحيات الطلبات",
  "roles.permissionGroups.inventory": "صلاحيات المخزون",
  "roles.permissionGroups.usersRoles": "صلاحيات المستخدمين والأدوار",
  "roles.permissionGroups.websiteUsers": "صلاحيات مستخدمي الموقع",
  "roles.permissionGroups.dashboard": "صلاحيات لوحة التحكم",
  "roles.permissionGroups.homepage": "صلاحيات الصفحة الرئيسية",
  "roles.permissionGroups.categoryLanding": "صلاحيات صفحة التصنيفات",
  "roles.permissionGroups.productListing": "صلاحيات صفحة قائمة المنتجات",
  "roles.permissionGroups.aboutUs": "صلاحيات صفحة من نحن",
  "roles.permissionGroups.contactUs": "صلاحيات صفحة اتصل بنا",
  "roles.permissionGroups.contactInquiries": "صلاحيات استفسارات التواصل",
  "roles.permissionGroups.reviews": "صلاحيات المراجعات",
  "roles.permissionGroups.customerRisk": "صلاحيات مخاطر العملاء",
  "roles.permissionGroups.reports": "صلاحيات التقارير",
  "roles.permissionGroups.commerceSettings": "صلاحيات إعدادات التجارة",
  "roles.permissionGroups.other": "صلاحيات أخرى",
  "roles.permissionRequired": "يجب تعيين صلاحية واحدة على الأقل",
  "roles.backToRoles": "العودة إلى الأدوار",
  "roles.breadcrumb": "التنقل في محرر الأدوار",
  "roles.createPageSubtitle": "حدّد معلومات الدور وعيّن الصلاحيات التي يحتاج إليها.",
  "roles.editPageSubtitle": "راجع معلومات الدور وحدّث الصلاحيات المُعيّنة له.",
  "roles.loadError": "تعذّر تحميل الدور.",
  "roles.retry": "إعادة المحاولة",
  "roles.search": "بحث في الأدوار...",
  "roles.allStatuses": "كل الحالات",
  "roles.sortByCreated": "تاريخ الإنشاء",
  "roles.noRoles": "لا توجد أدوار",
  "roles.nameRequired": "اسم الدور مطلوب",
  "roles.confirmDeleteTitle": "حذف الدور",
  "roles.confirmDelete": "هل أنت متأكد أنك تريد حذف هذا الدور؟",
  "excel.dropzone": "اسحب وأفلت الملف هنا، أو انقر للتصفح",
  "excel.acceptedFormats": "الصيغ المقبولة: .xlsx، .csv",
  "excel.maxSize": "الحد الأقصى لحجم الملف: 10 ميجابايت",
  "excel.columnFormat": "تنسيق الأعمدة المطلوبة:",
  "excel.column": "العمود",
  "excel.type": "النوع",
  "excel.requiredField": "مطلوب",
  "excel.optionalField": "اختياري",
  "excel.example": "مثال",
  "excel.importResults": "نتائج الاستيراد",
  "excel.rowsImported": "صفوف تم استيرادها",
  "excel.rowsFailed": "صفوف فشلت",
  "excel.errorRow": "صف {{row}}",
  "website.nav.home": "الرئيسية",
  "website.nav.shop": "المتجر",
  "website.nav.products": "المنتجات",
  "website.nav.offers": "العروض",
  "website.nav.about": "من نحن",
  "website.nav.contact": "تواصل معنا",
  "website.nav.search": "بحث",
  "website.nav.wishlist": "المفضلة",
  "website.nav.cart": "السلة",
  "website.nav.account": "الحساب",
  "website.nav.profile": "ملفي الشخصي",
  "website.nav.label": "التنقل في الموقع",
  "website.nav.mobileLabel": "التنقل في الموقع على الهاتف",
  "website.nav.toggle": "فتح أو إغلاق قائمة التنقل",
  "website.nav.switchLanguage": "تبديل اللغة",
  "website.pageTitle.home": "الرئيسية",
  "website.pageTitle.products": "المنتجات",
  "website.pageTitle.product": "المنتج",
  "website.pageTitle.cart": "السلة",
  "website.pageTitle.checkout": "إتمام الطلب",
  "website.pageTitle.profile": "ملفي الشخصي",
  "website.pageTitle.about": "من نحن",
  "website.pageTitle.contact": "تواصل معنا",
  "website.pageTitle.order": "الطلب",
  "website.pageTitle.notFound": "الصفحة غير موجودة",
  "website.seo.homeDescription": "{{company}} — تسوّق أحدث منتجاتنا وتشكيلاتنا.",
  "website.seo.productsDescription": "تسوّق منتجات {{company}}.",
  "website.seo.categoryDescription": "{{category}} لدى {{company}}. تصفّح {{category}} والمنتجات ذات الصلة.",
  "website.seo.productDescription": "{{product}} من {{company}}.",
  "website.seo.aboutDescription": "تعرّف على {{company}}.",
  "website.seo.contactDescription": "تواصل مع {{company}}.",
  "website.auth.welcome": "مرحباً",
  "website.auth.loginTitle": "سجّل الدخول للمتابعة",
  "website.auth.registerTitle": "إنشاء حساب",
  "website.auth.loginSubtitle": "الوصول إلى المفضلة والسلة وملفك دون مغادرة الصفحة.",
  "website.auth.registerSubtitle": "انضم إلى هذا المتجر باسمك وبريدك وتاريخ ميلادك وصورة اختيارية.",
  "website.auth.loginTab": "تسجيل الدخول",
  "website.auth.registerTab": "إنشاء حساب",
  "website.auth.loginCta": "تسجيل الدخول",
  "website.auth.registerCta": "إنشاء الحساب",
  "website.auth.loginFailed": "تعذر تسجيل الدخول. تحقق من بياناتك وحاول مرة أخرى.",
  "website.auth.invalidCredentials": "بيانات الدخول غير صحيحة",
  "website.auth.tooManyRequests": "عدد المحاولات كبير جداً. يرجى المحاولة لاحقاً.",
  "website.auth.registrationFailed": "تعذر إنشاء الحساب. يرجى المحاولة مرة أخرى.",
  "website.auth.email": "البريد الإلكتروني",
  "website.auth.password": "كلمة المرور",
  "website.auth.confirmPassword": "تأكيد كلمة المرور",
  "website.auth.firstName": "الاسم الأول",
  "website.auth.lastName": "اسم العائلة",
  "website.auth.dateOfBirth": "تاريخ الميلاد",
  "website.auth.dateOfBirthRequired": "تاريخ الميلاد مطلوب",
  "website.auth.invalidDateOfBirth": "أدخل تاريخ ميلاد صالحاً",
  "website.auth.addPhoto": "صورة",
  "website.auth.photoHint": "صورة شخصية اختيارية. JPEG أو PNG حتى 5MB.",
  "website.auth.passwordMin": "يجب أن تكون كلمة المرور 8 أحرف على الأقل.",
  "website.auth.passwordWeak": "كلمة المرور لا تستوفي الشروط المطلوبة.",
  "website.auth.passwordReqTitle": "يجب أن تتضمن كلمة المرور:",
  "website.auth.passwordReqMinLength": "8 أحرف على الأقل",
  "website.auth.passwordReqLowercase": "حرفاً صغيراً واحداً (a–z)",
  "website.auth.passwordReqUppercase": "حرفاً كبيراً واحداً (A–Z)",
  "website.auth.passwordReqNumber": "رقماً واحداً (0–9)",
  "website.auth.passwordReqSpecial": "رمزاً خاصاً واحداً (!@#$…)",
  "website.auth.passwordStrong": "كلمة المرور قوية",
  "website.auth.passwordMismatch": "كلمتا المرور غير متطابقتين.",
  "website.auth.emailAlreadyRegistered": "هذا البريد الإلكتروني مسجل مسبقاً.",
  "website.auth.invalidName": "أدخل اسماً صالحاً لا يتجاوز 100 حرف.",
  "website.auth.invalidPhoto": "اختر صورة شخصية صالحة وحاول مرة أخرى.",
  "website.auth.favoritesNeedUser": "المفضلة تتطلب حساب عميل. سجّل الدخول أو أنشئ حساب عميل.",
  "website.auth.cartComingSoon": "تم تسجيل دخولك. سلة التسوق قادمة قريباً.",
  "website.auth.emailNotVerified": "يرجى التحقق من بريدك الإلكتروني قبل تسجيل الدخول.",
  "website.auth.otpTitle": "تحقق من بريدك الإلكتروني",
  "website.auth.otpSubtitle": "أدخل الرمز الذي أرسلناه إلى بريدك الإلكتروني.",
  "website.auth.forgotTitle": "إعادة تعيين كلمة المرور",
  "website.auth.forgotSubtitle": "سنرسل رمز إعادة التعيين إلى بريدك الإلكتروني.",
  "website.auth.resetTitle": "تعيين كلمة مرور جديدة",
  "website.auth.resetSubtitle": "أدخل الرمز من بريدك واختر كلمة مرور جديدة.",
  "website.auth.otpCode": "رمز التحقق",
  "website.auth.verifyCta": "تحقق",
  "website.auth.resendCta": "إعادة إرسال الرمز",
  "website.auth.resendWait": "أعد الإرسال خلال {{seconds}} ث",
  "website.auth.forgotPassword": "نسيت كلمة المرور؟",
  "website.auth.sendResetCta": "إرسال رمز إعادة التعيين",
  "website.auth.resetCta": "إعادة تعيين كلمة المرور",
  "website.auth.newPassword": "كلمة المرور الجديدة",
  "website.auth.backToLogin": "العودة لتسجيل الدخول",
  "website.auth.otpInvalid": "الرمز غير صالح أو منتهٍ.",
  "website.auth.otpExpired": "انتهت صلاحية الرمز. اطلب رمزاً جديداً.",
  "website.auth.otpBlocked": "التحقق متوقف مؤقتاً. حاول لاحقاً.",
  "website.auth.otpResendCooldown": "يرجى الانتظار قبل طلب رمز جديد.",
  "website.auth.otpMaxAttempts": "محاولات غير صحيحة كثيرة. حاول لاحقاً.",
  "website.auth.otpMaxResends": "تم طلب رموز كثيرة. حاول لاحقاً.",
  "website.auth.emailDeliveryFailed": "تعذر إرسال البريد الإلكتروني. حاول مرة أخرى.",
  "website.auth.otpResendFailed": "تعذر إعادة إرسال الرمز. حاول مرة أخرى.",
  "website.auth.resetRequestFailed": "تعذر إرسال رمز إعادة التعيين. حاول مرة أخرى.",
  "website.auth.resetFailed": "تعذر إعادة تعيين كلمة المرور. حاول مرة أخرى.",
  "website.profile.signInPrompt": "سجّل الدخول لعرض ملفك والمفضلة.",
  "website.profile.companyAccount": "حساب المتجر",
  "website.profile.logout": "تسجيل الخروج",
  "website.profile.tabAccount": "الحساب",
  "website.profile.tabFavorites": "مفضلتي",
  "website.profile.accountHint": "تفاصيل حسابك في هذا المتجر.",
  "website.profile.favoritesEmpty": "لا توجد مفضلات بعد. أضف منتجات أثناء التسوّق لحفظها هنا.",
  "website.profile.removeFavorite": "إزالة",
  "website.profile.saveChanges": "حفظ التغييرات",
  "website.profile.saved": "تم تحديث الملف الشخصي.",
  "website.profile.saveFailed": "تعذر حفظ الملف الشخصي. حاول مرة أخرى.",
  "website.profile.changePhoto": "تغيير الصورة",
  "website.profile.cropPhoto": "قص صورة الملف الشخصي",
  "website.profile.cropPhotoHint": "ضع الصورة داخل إطار الملف الشخصي الدائري.",
  "website.profile.emailLocked": "البريد الإلكتروني يُستخدم لتسجيل الدخول ولا يمكن تغييره من هنا.",
  "website.profile.nameRequired": "الاسم الأول واسم العائلة مطلوبان.",
  "website.profile.currentPassword": "كلمة المرور الحالية",
  "website.profile.newPassword": "كلمة المرور الجديدة",
  "website.profile.confirmNewPassword": "تأكيد كلمة المرور الجديدة",
  "website.profile.changePassword": "تغيير كلمة المرور",
  "website.profile.passwordChanged": "تم تحديث كلمة المرور.",
  "website.profile.passwordChangeFailed": "تعذر تحديث كلمة المرور. حاول مرة أخرى.",
  "website.profile.passwordMismatch": "كلمتا المرور غير متطابقتين.",
  "website.profile.invalidCurrentPassword": "كلمة المرور الحالية غير صحيحة.",
  "website.profile.companyRedirectTitle": "أدِر متجرك من لوحة التحكم",
  "website.profile.companyRedirectBody": "حسابات الشركة تعدّل الهوية والكتالوج والإعدادات من لوحة التحكم وليس من ملف المتجر.",
  "website.profile.openDashboard": "فتح لوحة التحكم",
  "website.status.loadingTitle": "جاري تحميل الموقع",
  "website.status.loadingMessage": "جاري تجهيز المتجر…",
  "website.status.notFoundTitle": "الموقع غير موجود",
  "website.status.notFoundMessage": "تعذر العثور على الشركة المطلوبة.",
  "website.status.comingSoonTitle": "الموقع قريباً",
  "website.status.comingSoonMessage": "لم يتم نشر هذا المتجر بعد.",
  "website.status.errorTitle": "تعذر تحميل الموقع",
  "website.status.errorMessage": "يرجى المحاولة مرة أخرى لاحقاً.",
  "website.validation.title": "إدخال غير صالح أو حقول مطلوبة مفقودة",
  "website.validation.subtitle": "حدثت مشكلة في الإرسال. يرجى مراجعة الأقسام التالية.",
  "website.validation.issueCount": "تم العثور على ({{count}}) خطأ.",
  "website.validation.navigationHint": "انقر على الخطأ للانتقال إلى القسم.",
  "website.validation.close": "إغلاق",
  "website.validation.errorGroup": "خطأ",
  "website.validation.order": "يجب أن يكون ترتيب الأقسام متصلاً.",
  "website.validation.heroFirst": "يجب أن يبقى القسم الرئيسي أولاً.",
  "website.validation.heading": "أضف عنوان اللغة {{locale}}.",
  "website.validation.mediaUuid": "يجب أن يشير الوسيط إلى معرّف صالح.",
  "website.validation.catalogIds": "يجب أن تكون معرّفات الكتالوج أرقاماً موجبة.",
  "website.validation.chooseCategory": "اختر تصنيفاً واحداً على الأقل.",
  "website.validation.addProduct": "أضف معرّف منتج واحداً على الأقل.",
  "website.validation.addItem": "أضف عنصراً واحداً على الأقل.",
  "website.validation.heroRequired": "القسم الرئيسي مطلوب.",
  "website.validation.heroMobileMedia": "أضف صورة القسم الرئيسي المطلوبة للهاتف.",
  "website.validation.footerContent": "أضف محتوى التذييل باللغة {{locale}}.",
  "website.validation.footerLogo": "يجب أن يشير شعار التذييل إلى معرّف وسائط صالح.",
  "website.validation.richTextTooLongPlain": "يتجاوز النص المنسّق الحد الأقصى للنص العادي (5,000 حرف).",
  "website.validation.richTextTooLongHtml": "يتجاوز النص المنسّق الحد الأقصى لـ HTML (20,000 حرف).",
  "website.validation.richTextUnsafe": "يحتوي النص المنسّق على محتوى غير مسموح أو غير آمن.",
  "website.cms.editor": "محرر الصفحة الرئيسية",
  "website.cms.previewDraft": "معاينة مسودة الصفحة الرئيسية",
  "website.cms.unsaved": "تغييرات غير محفوظة",
  "website.cms.upToDate": "المسودة محدّثة",
  "website.cms.preview": "معاينة",
  "website.cms.edit": "تعديل",
  "website.cms.saving": "جارٍ الحفظ…",
  "website.cms.saveDraft": "حفظ المسودة",
  "website.cms.publishing": "جارٍ النشر…",
  "website.cms.publish": "نشر",
  "website.cms.exit": "الخروج من محرر الصفحة الرئيسية",
  "website.cms.addSection": "إضافة قسم",
  "website.cms.allAdded": "تمت إضافة جميع الأقسام المتاحة.",
  "website.cms.actionFailed": "فشل إجراء الصفحة الرئيسية",
  "website.cms.saveFailed": "فشل حفظ المسودة.",
  "website.cms.publishFailed": "فشل النشر.",
  "website.cms.leaveUnsaved": "لديك تغييرات غير محفوظة. هل تريد المغادرة دون حفظ؟",
  "website.cms.exitUnsaved": "لديك تغييرات غير محفوظة. هل تريد الخروج دون حفظ؟",
  "website.cms.editHomepage": "تعديل الصفحة الرئيسية",
  "website.cms.exitEditMode": "الخروج من وضع التعديل",
  "website.cms.previewHomepage": "معاينة المسودة",
  "website.cms.draftLoadFailed": "تعذر تحميل مسودة الصفحة الرئيسية.",
  "website.cms.editSection": "تعديل {{section}}",
  "website.cms.closeSection": "إغلاق محرر {{section}}",
  "website.cms.moveUp": "نقل {{section}} لأعلى",
  "website.cms.moveDown": "نقل {{section}} لأسفل",
  "website.cms.deleteSection": "حذف {{section}}",
  "website.cms.editFooter": "تعديل التذييل",
  "website.cms.closeFooter": "إغلاق محرر التذييل",
  "website.section.hero": "القسم الرئيسي",
  "website.section.trustBar": "شريط الثقة",
  "website.section.shopByCategory": "التسوق حسب التصنيف",
  "website.section.promoBanner": "لافتة العرض",
  "website.section.newArrivals": "وصل حديثاً",
  "website.section.whyChooseUs": "لماذا تختارنا",
  "website.section.testimonials": "آراء العملاء",
  "website.editor.title": "العنوان",
  "website.editor.description": "الوصف",
  "website.editor.heading": "العنوان",
  "website.editor.ctaLabel": "نص زر الإجراء",
  "website.editor.ctaLink": "رابط الإجراء",
  "website.editor.alignment": "المحاذاة",
  "website.editor.start": "البداية",
  "website.editor.center": "الوسط",
  "website.editor.end": "النهاية",
  "website.editor.heroMedia": "وسائط القسم الرئيسي",
  "website.editor.heroMobileMedia": "وسائط قسم البطل للهاتف",
  "website.editor.item": "العنصر {{index}}",
  "website.editor.icon": "الأيقونة",
  "website.editor.remove": "إزالة",
  "website.editor.addItem": "إضافة عنصر",
  "website.editor.categoryIds": "معرّفات التصنيفات",
  "website.editor.imageShape": "شكل الصورة",
  "website.editor.circle": "دائري",
  "website.editor.square": "مربع",
  "website.editor.message": "الرسالة",
  "website.editor.background": "الخلفية",
  "website.editor.primary": "رئيسية",
  "website.editor.accent": "تمييز",
  "website.editor.neutral": "محايدة",
  "website.editor.bannerMedia": "وسائط اللافتة",
  "website.editor.mode": "الوضع",
  "website.editor.automatic": "تلقائي",
  "website.editor.manual": "يدوي",
  "website.editor.limit": "الحد",
  "website.editor.categoryFilters": "تصفية التصنيفات (اختياري)",
  "website.editor.productIds": "معرّفات المنتجات",
  "website.editor.testimonial": "رأي العميل {{index}}",
  "website.editor.quote": "الاقتباس",
  "website.editor.author": "الاسم",
  "website.editor.role": "الصفة",
  "website.editor.rating": "التقييم",
  "website.editor.authorPhoto": "صورة العميل",
  "website.editor.addTestimonial": "إضافة رأي",
  "website.editor.footerDescription": "وصف التذييل",
  "website.editor.copyright": "حقوق النشر",
  "website.editor.footerLogo": "شعار التذييل",
  "website.editor.footerBrand": "الهوية",
  "website.editor.showLogo": "إظهار الشعار",
  "website.editor.showDescription": "إظهار الوصف",
  "website.editor.showDescriptionHelp": "نص منسّق باللغتين أسفل الشعار.",
  "website.editor.showCopyright": "إظهار حقوق النشر",
  "website.editor.showLinks": "إظهار روابط التذييل",
  "website.editor.showLinksHelp": "أزرار إجراءات مثل تسوق أو الرئيسية أو الموقع.",
  "website.editor.footerLinks": "روابط التذييل",
  "website.editor.footerLinksEmpty": "لا توجد روابط بعد. أضف تسوق أو الرئيسية أو إجراءات أخرى.",
  "website.editor.footerLinkItem": "الرابط {{index}}",
  "website.editor.addFooterLink": "إضافة رابط",
  "website.editor.removeFooterLink": "إزالة",
  "website.editor.linkLabelEn": "التسمية بالإنجليزية",
  "website.editor.linkLabelAr": "التسمية بالعربية",
  "website.editor.linkLabelEnPlaceholder": "مثلاً: Shop",
  "website.editor.linkLabelArPlaceholder": "مثلاً: تسوق",
  "website.editor.linkUrl": "الرابط",
  "website.editor.linkUrlPlaceholder": "#shop أو https://…",
  "website.editor.showSocialLinks": "إظهار وسائل التواصل",
  "website.editor.showSocialLinksHelp": "فيسبوك وإنستغرام فقط.",
  "website.editor.facebookUrl": "رابط فيسبوك",
  "website.editor.instagramUrl": "رابط إنستغرام",
  "website.editor.showMap": "إظهار خريطة الموقع",
  "website.editor.showMapHelp": "تضمين خريطة جوجل مع رابط اختياري لفتح الخرائط.",
  "website.editor.mapEmbed": "تضمين خرائط جوجل",
  "website.editor.mapEmbedHelp": "الصق كود iframe من خرائط جوجل ← مشاركة ← تضمين خريطة، أو الصق رابط التضمين فقط (…/maps/embed?…).",
  "website.editor.mapEmbedPlaceholder": "<iframe src=\"https://www.google.com/maps/embed?…\"> أو رابط التضمين",
  "website.editor.mapShareUrl": "رابط خرائط جوجل (اختياري)",
  "website.editor.mapShareUrlHelp": "رابط قصير مثل maps.app.goo.gl — يُستخدم لزر «فتح في الخرائط». لا يمكن تحويل الروابط القصيرة تلقائياً إلى تضمين.",
  "website.editor.mapPreview": "معاينة الخريطة",
  "website.editor.mapPreviewEmpty": "الصق iframe أو رابط التضمين لمعاينة الخريطة هنا.",
  "website.editor.mapPreviewShareOnly": "تم حفظ رابط المشاركة. أضف رابط التضمين لعرض الخريطة التفاعلية.",
  "website.editor.mediaSelected": "الوسائط: {{id}}",
  "website.editor.noMedia": "لم يتم اختيار وسائط",
  "website.editor.removeMedia": "إزالة الوسائط",
  "website.editor.categoryImage": "صورة التصنيف · {{name}}",
  "website.crop.title": "قص الصورة",
  "website.crop.description": "الوصف",
  "website.crop.descriptionPlaceholder": "تعليق يظهر أسفل الصورة",
  "website.crop.descriptionHelp": "سيُعرض هذا النص كتعليق أسفل الصورة",
  "website.crop.cancel": "إلغاء",
  "website.crop.save": "حفظ التغييرات",
  "website.crop.saving": "جارٍ الحفظ…",
  "website.crop.failed": "فشل الحفظ. يرجى المحاولة مرة أخرى.",
  "website.crop.hints.hero": "اقتصّ الصورة إلى {{size}} (16:9). هذا يطابق إطار قسم البطل في الصفحة الرئيسية تماماً حتى تظهر الصورة كاملة دون قص إضافي.",
  "website.crop.hints.heroMobile": "اقتصّ الصورة إلى {{size}} (9:16). هذه الصورة العمودية مطلوبة وتظهر على الهواتف.",
  "website.crop.hints.promoBanner": "اقتصّ الصورة إلى {{size}} (5:1). هذا يطابق إطار لافتة العرض تماماً حتى تملأ الصورة القسم دون فراغات أو لون خلفية.",
  "website.crop.hints.category": "يُفضّل {{size}} (1:1) لصور التصنيفات.",
  "website.crop.hints.testimonialAvatar": "يُفضّل {{size}} (1:1) لصور العملاء.",
  "website.crop.hints.footerLogo": "يُفضّل {{size}} (3:1) لشعار التذييل.",
  "website.shopByCategory.empty": "لا توجد تصنيفات للعرض حالياً.",
  "website.shopByCategory.emptyEditor": "لا توجد تصنيفات للعرض بعد. اختر التصنيفات من المحرر.",
  "website.footer.navigation": "روابط التذييل",
  "website.footer.followUs": "تابعنا",
  "website.footer.explore": "استكشف",
  "website.footer.visitUs": "زورونا",
  "website.footer.mapHeading": "موقعنا",
  "website.footer.mapTitle": "خريطة موقع المتجر",
  "website.footer.openInMaps": "فتح في الخرائط",
  "website.footer.openMapCard": "عرض الموقع على خرائط جوجل",
  "website.footer.facebook": "فيسبوك",
  "website.footer.instagram": "إنستغرام",
  "website.footer.email": "البريد الإلكتروني",
  "website.footer.phone": "الهاتف",
  "website.a11y.storeBenefits": "مميزات المتجر",
  "website.a11y.rating": "{{rating}} من 5 نجوم",
  "website.theme.light": "التبديل إلى الوضع الفاتح",
  "website.theme.dark": "التبديل إلى الوضع الداكن",
  "website.richText.visual": "مرئي",
  "website.richText.source": "المصدر",
  "website.richText.expand": "توسيع المحرر",
  "website.richText.editor": "المحرر",
  "website.richText.characterCount": "{{count}} حرفاً، الحد الأقصى {{max}}",
  "website.richText.insertTable": "إدراج جدول",
  "website.richText.rows": "الصفوف",
  "website.richText.columns": "الأعمدة",
  "website.richText.insert": "إدراج",
  "website.richText.bodyText": "نص المحتوى",
  "website.richText.regular": "عادي",
  "website.richText.removeLink": "إزالة الرابط",
  "website.richText.linkPlaceholder": "أدخل رابطاً أو بريداً إلكترونياً…",
  "website.richText.apply": "تطبيق",
  "website.richText.clearColor": "إزالة اللون",
  "website.richText.customColor": "مخصص",
  "website.richText.fontLabel": "الخط",
  "website.richText.sizeLabel": "الحجم (بكسل)",
  "website.richText.customSize": "مخصص",
  "website.richText.resetFontSize": "إعادة تعيين",
  "website.richText.textColor": "لون النص",
  "website.richText.textBackground": "خلفية النص",
  "website.richText.insertIcon": "إدراج أيقونة",
  "website.richText.iconStyle": "النمط",
  "website.richText.iconStyleAll": "كل الأنماط",
  "website.richText.iconStyleSolid": "ممتلئ",
  "website.richText.iconStyleRegular": "عادي",
  "website.richText.iconStyleBrands": "العلامات التجارية",
  "website.richText.iconSearchPlaceholder": "ابحث عن الأيقونات بالاسم أو الكلمة المفتاحية…",
  "website.richText.iconSearchLabel": "البحث عن الأيقونات",
  "website.richText.iconLoading": "جارٍ تحميل مكتبة الأيقونات…",
  "website.richText.iconLoadError": "تعذر تحميل مكتبة الأيقونات.",
  "website.richText.iconNoResults": "لا توجد أيقونات تطابق بحثك.",
  "website.richText.iconCount": "تم العثور على {{count}} أيقونة",
  "website.richText.iconRefine": "ضيّق نطاق البحث لرؤية المزيد من النتائج",
  "website.richText.iconAvailable": "الأيقونات المتاحة",
  "website.richText.tableLabel": "الجدول:",
  "website.richText.addColumnBefore": "+ عمود قبل",
  "website.richText.addColumnAfter": "+ عمود بعد",
  "website.richText.deleteColumn": "- عمود",
  "website.richText.addRowBefore": "+ صف قبل",
  "website.richText.addRowAfter": "+ صف بعد",
  "website.richText.deleteRow": "- صف",
  "website.richText.deleteTable": "حذف الجدول",
  "website.richText.tooltips.fontFamily": "اختر نوع الخط للنص المحدد",
  "website.richText.tooltips.bold": "عريض — لتأكيد النص المهم",
  "website.richText.tooltips.italic": "مائل — لتأكيد خفيف أو عناوين",
  "website.richText.tooltips.textColor": "لون النص — تغيير لون النص المحدد",
  "website.richText.tooltips.highlightColor": "تمييز — إضافة لون خلفية خلف النص",
  "website.richText.tooltips.link": "إدراج أو تعديل رابط / بريد إلكتروني",
  "website.richText.tooltips.removeLink": "إزالة الرابط من النص المحدد",
  "website.richText.tooltips.bulletList": "قائمة نقطية — عناصر غير مرتبة",
  "website.richText.tooltips.orderedList": "قائمة مرقمة — خطوات أو ترتيب",
  "website.richText.tooltips.insertTable": "إدراج جدول في المحتوى",
  "common.decrease": "تقليل الكمية",
  "common.increase": "زيادة الكمية",
  "website.nav.categories": "التصنيفات",
  "website.a11y.viewProduct": "عرض {{product}}",
  "website.chat.title": "مساعد التسوق",
  "website.chat.subtitle": "أساعدك في التسوق ضمن {{store}}",
  "website.chat.placeholder": "صف ما تحتاجه، أو اسأل عن طلبك…",
  "website.chat.send": "إرسال",
  "website.chat.open": "فتح مساعد التسوق",
  "website.chat.close": "إغلاق المساعد",
  "website.chat.newChat": "محادثة جديدة",
  "website.chat.history": "المحادثات",
  "website.chat.emptyHistory": "ستظهر محادثاتك السابقة هنا.",
  "website.chat.untitled": "محادثة جديدة",
  "website.chat.deleteChat": "حذف المحادثة",
  "website.chat.deleteChatConfirm": "سيتم حذف المحادثة نهائياً ولا يمكن التراجع عن ذلك.",
  "website.chat.historyReadOnlyHint": "المحادثات السابقة للعرض فقط.",
  "website.chat.historyReadOnlyTitle": "هذه المحادثة للعرض فقط",
  "website.chat.historyReadOnly": "لا يمكنك إرسال رسائل في المحادثات السابقة. ابدأ محادثة جديدة لمتابعة التسوق مع المساعد.",
  "website.chat.emptyTitle": "كيف أساعدك في التسوق؟",
  "website.chat.empty": "اسأل عن منتجات بمقاسك ولونك. سجّل الدخول لمتابعة الطلب.",
  "website.chat.signInForOrders": "يرجى تسجيل الدخول لمتابعة طلباتك.",
  "website.chat.signIn": "تسجيل الدخول",
  "website.chat.error": "المساعد غير متاح حالياً.",
  "website.chat.error.FORBIDDEN": "لا يمكنك الوصول إلى هذا الطلب.",
  "website.chat.error.NOT_FOUND": "لم يتم العثور على نتيجة مطابقة.",
  "website.chat.error.SIGN_IN_REQUIRED": "يرجى تسجيل الدخول لمتابعة طلباتك.",
  "website.chat.error.NETWORK": "تعذر الوصول إلى مساعد التسوق. حاول مرة أخرى.",
  "website.chat.error.UNKNOWN": "المساعد غير متاح حالياً.",
  "website.chat.orderStatus": "الطلب {{number}}: {{status}}",
  "website.chat.orderCardTitle": "حالة الطلب",
  "website.chat.orderPlaced": "تاريخ الطلب {{date}}",
  "website.chat.orderItemFallback": "منتج",
  "website.chat.noProducts": "لا توجد منتجات متاحة مطابقة.",
  "website.chat.viewProduct": "عرض المنتج",
  "website.chat.thinking": "جاري التفكير…",
  "website.chat.promptFind": "ابحث لي عن منتج…",
  "website.chat.promptLatest": "اعرض أحدث المنتجات",
  "website.chat.promptTrack": "تتبّع طلبي",
  "website.catalog.loading": "جاري تحميل الكتالوج…",
  "website.catalog.loadFailed": "تعذر تحميل الكتالوج",
  "website.category.title": "تسوق حسب التصنيف",
  "website.category.subtitle": "تصفح المجموعات واعثر على ما يناسبك.",
  "website.category.all": "كل التصنيفات",
  "website.category.filterLabel": "التصفية حسب التصنيف",
  "website.category.productCount": "{{count}} منتج",
  "website.category.collection": "التشكيلة",
  "website.category.empty": "لا توجد تصنيفات متاحة حالياً.",
  "website.product.title": "منتجاتنا",
  "website.product.subtitle": "استكشف أحدث المنتجات في متجرنا.",
  "website.product.search": "ابحث عن المنتجات…",
  "website.product.sortLabel": "ترتيب المنتجات",
  "website.product.sortNewest": "الأحدث",
  "website.product.sortPriceAsc": "السعر: من الأقل للأعلى",
  "website.product.sortPriceDesc": "السعر: من الأعلى للأقل",
  "website.product.sortName": "الاسم",
  "website.product.empty": "لا توجد منتجات تطابق عوامل التصفية.",
  "website.product.pagination": "صفحات المنتجات",
  "website.product.pageOf": "الصفحة {{page}} من {{total}}",
  "website.product.shopNow": "تسوق الآن",
  "website.product.priceUnder25": "أقل من 25",
  "website.product.price25to50": "من 25 إلى 50",
  "website.product.price50to100": "من 50 إلى 100",
  "website.product.priceOver100": "100 فأكثر",
  "website.product.filters.title": "عوامل تصفية المنتجات",
  "website.product.filters.categories": "التصنيفات",
  "website.product.filters.price": "السعر",
  "website.product.filters.color": "اللون",
  "website.product.filters.clearAll": "مسح كل عوامل التصفية",
  "website.productCard.new": "جديد",
  "website.productCard.sale": "تخفيض",
  "website.productCard.soldOut": "نفد المخزون",
  "website.productCard.off": "خصم",
  "website.productCard.wishlist": "إضافة إلى المفضلة",
  "website.productDetails.reviews": "{{count}} مراجعة",
  "website.productDetails.outOfStock": "نفد المخزون",
  "website.productDetails.available": "المتوفر: {{count}} قطع",
  "website.productDetails.sizeGuide": "دليل المقاسات",
  "website.productDetails.addToCart": "أضف إلى السلة",
  "website.productDetails.freeShipping": "شحن مجاني",
  "website.productDetails.easyReturns": "إرجاع سهل",
  "website.productDetails.securePayment": "دفع آمن",
  "website.productDetails.viewImage": "عرض صورة المنتج {{index}}",
  "website.productDetails.secondaryImages": "صور إضافية للمنتج",
  "website.productDetails.imagePreview": "معاينة صورة المنتج",
  "website.productDetails.imageCounter": "{{current}} / {{total}}",
  "website.productDetails.showingColorImages": "صور اللون {{color}}",
  "website.productDetails.galleryLabel": "معرض صور المنتج",
  "website.productDetails.openImagePreview": "فتح معاينة الصورة بالحجم الكامل",
  "website.productDetails.notFound": "المنتج غير موجود",
  "website.productDetails.notFoundMessage": "هذا المنتج غير متاح أو لم يعد موجوداً.",
  "website.productDetails.related": "قد يعجبك أيضاً",
  "website.productDetails.share": "مشاركة المنتج",
  "website.productDetails.shareTitle": "مشاركة",
  "website.productDetails.shareHint": "أرسل هذا المنتج لشخص ما، أو انسخ الرابط.",
  "website.productDetails.shareMessage": "اطلع على {{product}}",
  "website.productDetails.shareCopyLink": "رابط المنتج",
  "website.productDetails.shareCopy": "نسخ",
  "website.productDetails.shareCopyCta": "نسخ الرابط",
  "website.productDetails.shareCopied": "تم النسخ",
  "website.productDetails.shareCopyFailed": "تعذر نسخ الرابط. يرجى نسخه يدوياً.",
  "website.productDetails.shareVia": "شارك عبر",
  "website.productDetails.shareNative": "المزيد",
  "website.productDetails.shareChannel.whatsapp": "واتساب",
  "website.productDetails.shareChannel.facebook": "فيسبوك",
  "website.productDetails.shareChannel.telegram": "تيليجرام",
  "website.productDetails.shareChannel.x": "X",
  "website.productDetails.shareChannel.email": "البريد",
  "website.cms.catalogEditor": "محرر واجهة الصفحة",
  "products.stockQty": "كمية المخزون",
  "products.stockQtyRequired": "كمية المخزون مطلوبة",
  "products.tags": "الوسوم",
  "products.selectTags": "اختر الوسوم",
  "products.createTag": "إنشاء وسم «{{name}}»",
  "categories.nameAr": "اسم التصنيف بالعربية",
  "categories.nameArPlaceholder": "الاسم العربي اختياري",
  "categories.descriptionAr": "الوصف بالعربية",
  "categories.descriptionArPlaceholder": "الوصف بالعربية اختياري",
  "tags.title": "الوسوم",
  "tags.subtitle": "نظّم المنتجات بوسوم قابلة لإعادة الاستخدام لترتيب المنتجات ذات الصلة.",
  "tags.create": "إنشاء وسم",
  "tags.edit": "تعديل الوسم",
  "tags.name": "اسم الوسم",
  "tags.nameAr": "الاسم بالعربية",
  "tags.nameRequired": "اسم الوسم مطلوب",
  "tags.products": "المنتجات",
  "tags.empty": "لا توجد وسوم بعد",
  "tags.confirmDelete": "حذف هذا الوسم غير المستخدم؟",
  "tags.deleteInUse": "هذا الوسم مرتبط بـ {{count}} منتج/منتجات ولا يمكن حذفه.",
  "testimonials.title": "آراء العملاء",
  "testimonials.subtitle": "راجع مشاركات العملاء، اعتمدها، وروّج المفضلة منها إلى الصفحة الرئيسية.",
  "testimonials.filterStatus": "الحالة",
  "testimonials.allStatuses": "كل الحالات",
  "testimonials.status.PENDING": "قيد المراجعة",
  "testimonials.status.APPROVED": "معتمد",
  "testimonials.status.REJECTED": "مرفوض",
  "testimonials.promoted": "مُروَّج",
  "testimonials.rating": "{{rating}} / 5",
  "testimonials.empty": "لا توجد آراء بعد",
  "testimonials.approve": "اعتماد",
  "testimonials.reject": "رفض",
  "testimonials.promote": "ترويج للصفحة الرئيسية",
  "testimonials.unpromote": "إزالة من الصفحة الرئيسية",
  "website.testimonials.empty": "لا توجد قصص عملاء للعرض حالياً.",
  "website.testimonials.emptyEditor": "ستظهر قصص العملاء هنا بعد الترويج.",
  "website.testimonials.shareHeading": "شارك تجربتك",
  "website.testimonials.shareHint": "تتم مراجعة رأيك قبل ظهوره على الموقع.",
  "website.testimonials.authorName": "اسمك",
  "website.testimonials.authorRole": "الدور أو المدينة (اختياري)",
  "website.testimonials.quote": "رأيك",
  "website.testimonials.rating": "التقييم",
  "website.testimonials.submit": "إرسال الرأي",
  "website.testimonials.submitSuccess": "شكراً! تم إرسال رأيك للمراجعة.",
  "website.testimonials.submitError": "تعذر إرسال رأيك. حاول مرة أخرى.",
  "website.testimonials.formRequired": "الاسم والرأي مطلوبان.",
  "website.editor.testimonialsFromModeration": "آراء الصفحة الرئيسية تأتي من مراجعات العملاء المُروَّجة.",
  "website.editor.openTestimonials": "فتح المراجعة",
  "products.nameAr": "الاسم بالعربية",
  "products.nameArPlaceholder": "الاسم العربي اختياري",
  "products.descriptionAr": "الوصف بالعربية",
  "products.descriptionArPlaceholder": "أدخل وصف المنتج باللغة العربية",
  "products.image": "صورة المنتج",
  "products.imageRequired": "صورة المنتج مطلوبة",
  "products.imageHint": "صورة مربعة مطلوبة. تطابق قص بطاقة المنتج في المتجر (1:1).",
  "products.cropHint": "اقتصّ الصورة مربعة (1:1) لتملأ بطاقة المنتج دون فراغات.",
  "products.variantsHelp": "كل متغير هو وحدة بيع مستقلة. اختر مجموعة (مثل اللون) ثم خياراً (مثل أحمر). أضف صفاً آخر للمقاس إن لزم. يمكنك إنشاء مجموعات/خيارات جديدة من القائمة.",
  "priceRules.percentageLabel": "نسبة خصم",
  "priceRules.fixedAmountLabel": "مبلغ خصم ثابت",
  "priceRules.fixedPriceLabel": "سعر نهائي ثابت",
  "priceRules.typeHint": "اختر كيف تغيّر هذه القاعدة سعر البيع في المتجر.",
  "priceRules.percentageHint": "مثال: القيمة 15 تعني أن العميل يدفع أقل بنسبة 15٪ من سعر البيع.",
  "priceRules.fixedAmountHint": "مثال: القيمة 5 تطرح 5 من سعر البيع (بوحدة العملة).",
  "priceRules.fixedPriceHint": "مثال: القيمة 19.99 تجعل سعر المتجر 19.99 بالضبط بغض النظر عن سعر البيع العادي.",
  "products.variantsGroup": "المجموعة",
  "products.variantsOption": "الخيار",
  "products.selectGroup": "اختر المجموعة",
  "products.selectOption": "اختر الخيار",
  "products.createGroup": "إنشاء مجموعة «{{name}}»",
  "products.createOption": "إنشاء خيار «{{name}}»",
  "common.filtersToggle": "إظهار الفلاتر",
  "common.filtersHide": "إخفاء الفلاتر",
  "priceRules.helpTitle": "كيف تعمل قواعد الأسعار",
  "priceRules.helpBody": "تعمل قواعد الأسعار تلقائياً على تغيير سعر المتجر لفترة محددة. اختر نسبة خصم، أو مبلغ خصم ثابت، أو سعراً نهائياً ثابتاً، ويمكنك تحديد نطاق تاريخ اختياري، وضبط الأولوية لتحديد القاعدة الفائزة عند تداخل عدة قواعد.",
  "website.content.editPage": "تعديل الصفحة",
  "website.content.previewPage": "معاينة المسودة",
  "website.content.editor.titleBar": "محرر صفحة المحتوى",
  "website.content.editor.eyebrow": "العنوان التمهيدي",
  "website.content.editor.title": "العنوان",
  "website.content.editor.description": "الوصف",
  "website.content.editor.body": "القصة",
  "website.content.editor.formTitle": "عنوان النموذج",
  "website.content.editor.formDescription": "مقدمة النموذج",
  "website.content.editor.address": "العنوان",
  "website.content.editor.email": "البريد الإلكتروني",
  "website.content.editor.phone": "الهاتف",
  "website.content.editor.hours": "ساعات العمل",
  "website.content.editor.showPhone": "إظهار الهاتف",
  "website.content.editor.ctaLabel": "نص الزر",
  "website.content.editor.ctaHref": "رابط الزر",
  "website.content.editor.mapEmbed": "رابط تضمين خرائط Google أو iframe",
  "website.content.editor.mapLink": "رابط الخريطة العام",
  "website.content.editor.showMap": "إظهار الخريطة",
  "website.content.editor.alignment": "محاذاة المحتوى",
  "website.content.editor.media": "صورة القسم",
  "website.content.editor.value": "القيمة",
  "website.content.editor.label": "التسمية",
  "website.content.editor.addItem": "إضافة عنصر",
  "website.content.section.hero": "الواجهة",
  "website.content.section.story": "القصة",
  "website.content.section.values": "القيم",
  "website.content.section.stats": "الإحصاءات",
  "website.content.section.cta": "دعوة لاتخاذ إجراء",
  "website.content.section.contactWorkspace": "مساحة التواصل",
  "website.content.section.map": "الخريطة",
  "website.content.validation.required": "العنوان مطلوب باللغتين.",
  "website.contact.form.name": "الاسم",
  "website.contact.form.email": "البريد الإلكتروني",
  "website.contact.form.phone": "الهاتف",
  "website.contact.form.subject": "الموضوع",
  "website.contact.form.message": "الرسالة",
  "website.contact.form.send": "إرسال الرسالة",
  "website.contact.form.sending": "جارٍ الإرسال…",
  "website.contact.form.success": "تم إرسال رسالتك بنجاح.",
  "website.contact.form.error": "تعذر إرسال رسالتك. حاول مرة أخرى.",
  "website.content.mapTitle": "خريطة الموقع",
  "website.content.openMap": "فتح في خرائط Google",
  "website.offers.title": "العروض الحالية",
  "website.offers.description": "يتم عرض المنتجات التي لديها خصم نشط.",
  "sidebar.contactInquiries": "استفسارات التواصل",
  "contactInquiries.title": "استفسارات التواصل",
  "contactInquiries.subtitle": "راجع الرسائل المرسلة من صفحة تواصل معنا العامة.",
  "contactInquiries.listTitle": "الرسائل",
  "contactInquiries.total": "{{count}} استفسار",
  "contactInquiries.empty": "لم يتم استلام أي استفسارات بعد.",
  "contactInquiries.loadFailed": "تعذر تحميل استفسارات التواصل.",
  "contactInquiries.detailFailed": "تعذر تحميل هذا الاستفسار.",
  "contactInquiries.selectPrompt": "اختر استفساراً لقراءة رسالته.",
  "contactInquiries.accessDenied": "ليس لديك صلاحية لعرض استفسارات التواصل.",
  "contactInquiries.email": "البريد الإلكتروني",
  "contactInquiries.phone": "الهاتف",
  "contactInquiries.message": "الرسالة",
  "auth.invalidCredentials": "بيانات الدخول غير صحيحة",
  "auth.tooManyRequests": "عدد المحاولات كبير جداً. يرجى المحاولة لاحقاً.",
  "auth.authorizedAccessOnly": "الدخول مخصص للشركات المصرح لها فقط.",
  "dashboard.viewWebsite": "عرض الموقع العام",
  "dashboard.viewMode.table": "عرض الجدول",
  "dashboard.viewMode.cards": "عرض البطاقات",
  "dashboard.noAccessiblePages": "لا يملك حسابك حالياً صلاحية الوصول إلى أي صفحة في لوحة التحكم. تواصل مع المسؤول.",
  "dashboard.overview.title": "نظرة عامة على لوحة التحكم",
  "dashboard.overview.subtitle": "ملخص مباشر للمتجر وآخر الأنشطة.",
  "dashboard.overview.loadFailed": "تعذر تحميل ملخص لوحة التحكم.",
  "dashboard.overview.recentActivity": "آخر الأنشطة",
  "dashboard.overview.noActivity": "لا توجد أنشطة حديثة بعد.",
  "dashboard.overview.storefrontTitle": "واجهة متجرك العامة",
  "dashboard.overview.storefrontDescription": "راجع تجربة العملاء ومحتوى الموقع المنشور.",
  "dashboard.metrics.products": "المنتجات",
  "dashboard.metrics.categories": "التصنيفات",
  "dashboard.metrics.users": "مستخدمو لوحة التحكم",
  "dashboard.metrics.inquiries": "استفسارات التواصل",
  "dashboard.metrics.pendingTestimonials": "الشهادات قيد المراجعة",
  "dashboard.activity.product": "منتج",
  "dashboard.activity.user": "مستخدم لوحة التحكم",
  "dashboard.activity.contact_inquiry": "استفسار تواصل",
  "dashboard.activity.testimonial": "شهادة عميل",
  "sidebar.commerce": "التجارة والطلبات",
  "sidebar.commerce.customerRisk": "مخاطر العملاء",
  "sidebar.commerce.reviews": "مراجعة التقييمات",
  "sidebar.commerce.settings": "إعدادات التجارة",
  "commerce.subtotal": "مجموع المنتجات",
  "commerce.deliveryFee": "رسوم التوصيل",
  "commerce.deliveryFeePending": "تُحدد لاحقاً",
  "commerce.deliveryPaidSeparately": "يحدد المتجر رسوم التوصيل وتُدفع منفصلة عند الاستلام.",
  "commerce.total": "الإجمالي",
  "commerce.items": "عناصر",
  "commerce.orderNumber": "الطلب رقم {{number}}",
  "commerce.payment.CLICK": "تحويل كليك",
  "commerce.payment.COD": "الدفع عند الاستلام",
  "commerce.status.PENDING_REVIEW": "بانتظار المراجعة",
  "commerce.status.CONFIRMED": "مؤكد",
  "commerce.status.PREPARING": "قيد التجهيز",
  "commerce.status.OUT_FOR_DELIVERY": "خرج للتوصيل",
  "commerce.status.DELIVERED": "تم التسليم",
  "commerce.status.REJECTED": "مرفوض",
  "commerce.status.CANCELLED": "ملغي",
  "commerce.status.UNPAID": "غير مدفوع",
  "commerce.status.PROOF_SUBMITTED": "تم إرسال الإثبات",
  "commerce.status.VERIFIED": "تم التحقق",
  "commerce.status.COLLECTED": "تم التحصيل",
  "commerce.status.PENDING": "قيد الانتظار",
  "commerce.status.APPROVED": "مقبول",
  "commerce.timeline.CREATED": "تم إنشاء الطلب",
  "commerce.timeline.STATUS_CHANGED": "تم تحديث حالة الطلب",
  "commerce.timeline.PAYMENT_CHANGED": "تم تحديث حالة الدفع",
  "commerce.timeline.DELIVERY_FEE_CHANGED": "تم تحديث رسوم التوصيل",
  "commerce.timeline.CANCELLED": "تم إلغاء الطلب",
  "commerce.cart.title": "سلة التسوق",
  "commerce.cart.subtitle": "راجع المنتجات والكميات قبل إتمام الطلب.",
  "commerce.cart.empty": "سلة التسوق فارغة",
  "commerce.cart.continueShopping": "متابعة التسوق",
  "commerce.cart.unavailable": "هذا العنصر غير متوفر حالياً.",
  "commerce.cart.summary": "ملخص الطلب",
  "commerce.cart.revalidated": "تُراجع الأسعار والخيارات والمخزون مجدداً عند إرسال الطلب.",
  "commerce.cart.checkout": "المتابعة للدفع",
  "commerce.cart.selectExactVariant": "يرجى اختيار خيارات المنتج المطلوبة، مثل اللون والمقاس، قبل إضافة المنتج إلى السلة.",
  "commerce.cart.added": "تمت الإضافة إلى السلة.",
  "commerce.cart.customerAccountRequired": "سجّل الدخول بحساب عميل لإضافة المنتجات إلى السلة.",
  "commerce.checkout.title": "إتمام الطلب",
  "commerce.checkout.couponTitle": "رمز الكوبون",
  "commerce.checkout.couponDescription": "أدخل رمز كوبون مؤهلاً لتطبيق خصمه على هذا الطلب.",
  "commerce.checkout.couponCode": "رمز الكوبون",
  "commerce.checkout.couponCodePlaceholder": "أدخل رمز الكوبون",
  "commerce.checkout.couponApply": "تطبيق الكوبون",
  "commerce.checkout.couponRemove": "إزالة الكوبون",
  "commerce.checkout.couponDuplicate": "تمت إضافة رمز الكوبون هذا بالفعل.",
  "commerce.checkout.couponApplyFailed": "تعذر تطبيق هذا الكوبون. تحقّق من الرمز وحاول مرة أخرى.",
  "commerce.checkout.couponOriginalSubtotal": "المجموع الأصلي",
  "commerce.checkout.couponAutomaticDiscount": "خصم تلقائي",
  "commerce.checkout.couponDiscount": "خصم الكوبون",
  "commerce.checkout.couponTax": "الضريبة",
  "commerce.checkout.delivery": "بيانات التوصيل",
  "commerce.checkout.primaryPhone": "الهاتف الرئيسي",
  "commerce.checkout.backupPhone": "هاتف احتياطي (اختياري)",
  "commerce.checkout.city": "المدينة",
  "commerce.checkout.area": "المنطقة",
  "commerce.checkout.address": "العنوان الكامل",
  "commerce.checkout.notes": "ملاحظات الطلب (اختياري)",
  "commerce.checkout.payment": "طريقة الدفع",
  "commerce.checkout.codDescription": "ادفع قيمة الطلب والتوصيل عند وصوله.",
  "commerce.checkout.clickDescription": "حوّل الآن وارفع صورة واضحة لإثبات الدفع.",
  "commerce.checkout.proof": "صورة إثبات الدفع",
  "commerce.checkout.invalidPhone": "أدخل أرقام هاتف رئيسية واحتياطية صحيحة.",
  "commerce.checkout.proofRequired": "صورة إثبات الدفع مطلوبة لتحويل كليك.",
  "commerce.checkout.failed": "تعذر إرسال الطلب. راجع البيانات وحاول مجدداً.",
  "commerce.checkout.placeOrder": "إرسال الطلب",
  "commerce.orders.myOrders": "طلباتي",
  "commerce.orders.empty": "لا توجد طلبات بعد.",
  "commerce.orders.failed": "تعذر تحميل الطلبات.",
  "commerce.orders.notFound": "الطلب غير موجود",
  "commerce.orders.back": "العودة إلى طلباتي",
  "commerce.orders.reason": "السبب",
  "commerce.orders.timeline": "مراحل الطلب",
  "commerce.orders.cancel": "إلغاء الطلب",
  "commerce.orders.cancelReason": "ما سبب إلغاء هذا الطلب؟",
  "commerce.review.write": "قيّم هذا العنصر المستلم",
  "commerce.review.yourReview": "تقييمك",
  "commerce.review.placeholder": "شارك تجربتك مع هذا المنتج…",
  "commerce.review.submit": "إرسال للمراجعة",
  "commerce.review.customerReviews": "تقييمات العملاء",
  "commerce.review.customer": "عميل موثّق",
  "commerce.admin.orders": "الطلبات",
  "commerce.admin.ordersSubtitle": "مراجعة طلبات المتجر وتجهيزها وتدقيقها.",
  "commerce.admin.searchOrders": "ابحث بالطلب أو البريد أو الهاتف…",
  "commerce.admin.allStatuses": "جميع الحالات",
  "commerce.admin.allPayments": "جميع طرق الدفع",
  "commerce.admin.order": "الطلب",
  "commerce.admin.customer": "العميل",
  "commerce.admin.status": "الحالة",
  "commerce.admin.payment": "الدفع",
  "commerce.admin.area": "المنطقة",
  "commerce.admin.invoice": "طباعة الفاتورة",
  "commerce.admin.shippingLabel": "ملصق الشحن",
  "commerce.admin.shipTo": "الشحن إلى",
  "commerce.admin.product": "المنتج",
  "commerce.admin.sku": "رمز المخزون",
  "commerce.admin.qty": "الكمية",
  "commerce.admin.paymentProof": "إثبات دفع كليك",
  "commerce.admin.riskScore": "درجة الثقة",
  "commerce.admin.riskReason": "أدخل سبب قرار المخاطر الظاهر",
  "commerce.admin.removeBlacklist": "إزالة من القائمة السوداء",
  "commerce.admin.blacklist": "إضافة للقائمة السوداء",
  "commerce.admin.blacklisted": "في القائمة السوداء",
  "commerce.admin.risk": "مخاطر العملاء",
  "commerce.admin.riskSubtitle": "مؤشرات ثقة واضحة للدفع عند الاستلام وحالة الحظر.",
  "commerce.admin.reviews": "مراجعة التقييمات",
  "commerce.admin.reviewsSubtitle": "اعتماد تقييمات المشتريات الموثقة قبل نشرها.",
  "commerce.admin.searchReviews": "ابحث بالعميل أو المنتج أو نص التقييم…",
  "commerce.admin.noReviews": "لا توجد تقييمات.",
  "commerce.admin.rating": "التقييم",
  "commerce.admin.reviewBody": "المراجعة",
  "commerce.admin.inventory": "سجل المخزون",
  "commerce.admin.inventorySubtitle": "تدقيق حركات المخزون وإجراء التعديلات المصرح بها.",
  "commerce.admin.settings": "إعدادات التجارة",
  "commerce.admin.settingsSubtitle": "ضبط طرق الدفع وتعليمات كليك باللغتين.",
  "commerce.admin.reports": "تقارير التجارة",
  "commerce.admin.reportsSubtitle": "تحليل الطلبات المؤكدة والمبيعات المحققة حسب التاريخ.",
  "commerce.admin.approve": "اعتماد",
  "commerce.admin.reject": "رفض",
  "commerce.admin.movement": "الحركة",
  "commerce.admin.balance": "الرصيد",
  "commerce.admin.date": "التاريخ",
  "commerce.admin.adjust": "تعديل",
  "commerce.admin.adjustQuantity": "كمية التعديل (استخدم رقماً سالباً لسحب المخزون)",
  "commerce.admin.adjustReason": "سبب تعديل المخزون",
  "commerce.admin.clickRecipient": "مستلم كليك",
  "commerce.admin.clickInstructions": "تعليمات كليك",
  "commerce.admin.bestSellers": "المنتجات الأكثر مبيعاً",
  "commerce.report.totalOrders": "إجمالي الطلبات",
  "commerce.report.pendingOrders": "الطلبات المعلقة",
  "commerce.report.deliveredOrders": "الطلبات المسلّمة",
  "commerce.report.realizedSales": "المبيعات المحققة",
  "commerce.report.averageOrderValue": "متوسط قيمة الطلب",
  "commerce.dashboard.dailySales": "مبيعات اليوم المحققة",
  "commerce.dashboard.monthlySales": "مبيعات الشهر المحققة",
  "commerce.cart.adding": "جارٍ الإضافة إلى السلة…",
  "commerce.cart.addFailed": "تعذّرت إضافة هذا المنتج إلى السلة.",
  "commerce.checkout.success": "تم إرسال طلبك بنجاح.",
  "commerce.checkout.required": "هذا الحقل مطلوب.",
  "commerce.checkout.country": "الدولة",
  "commerce.checkout.clickAlias": "اسم كليك",
  "commerce.checkout.clickPhone": "رقم هاتف كليك",
  "commerce.checkout.cropProof": "قص إثبات الدفع",
  "commerce.checkout.cropProofHint": "قص الإثبات بنسبة 4:3 المطابقة للمعاينة في لوحة الطلبات.",
  "commerce.orders.reasonRequired": "يجب إدخال السبب.",
  "commerce.orders.cancelled": "تم إلغاء الطلب.",
  "commerce.orders.cancelFailed": "تعذّر إلغاء الطلب.",
  "commerce.review.submitted": "تم إرسال تقييمك للمراجعة.",
  "commerce.review.submitFailed": "تعذّر إرسال تقييمك.",
  "commerce.review.commentRequired": "نص التقييم مطلوب.",
  "commerce.review.commentMinLength": "اكتب 10 أحرف على الأقل.",
  "commerce.review.commentMaxLength": "لا يمكن أن يتجاوز التقييم {{max}} حرفاً.",
  "commerce.admin.paymentAvailability": "إتاحة طرق الدفع",
  "commerce.admin.couponPolicy": "سياسة الكوبونات",
  "commerce.admin.couponPolicyHint": "حدّد ما إذا كان العميل يستطيع إدخال رمز كوبون واحد أو دمج عدة كوبونات مؤهلة في الطلب نفسه.",
  "commerce.admin.allowMultipleCoupons": "السماح بعدة كوبونات في الطلب",
  "commerce.admin.allowMultipleCouponsDescription": "عند التفعيل، تُطبّق كوبونات قواعد الأسعار المختلفة حسب الأولوية بعد الخصومات التلقائية.",
  "commerce.admin.clickEnabledHint": "يمكن للعملاء التحويل عبر كليك ورفع إثبات للمراجعة اليدوية.",
  "commerce.admin.clickAccount": "بيانات حساب كليك",
  "commerce.admin.clickAccountHint": "اختر الطريقة التي سيجد بها العملاء حساب كليك واعرض اسم صاحب الحساب.",
  "commerce.admin.clickIdentifierType": "نوع معرّف كليك",
  "commerce.admin.clickAlias": "الاسم المستعار",
  "commerce.admin.clickAliasHint": "استخدم اسم كليك الدقيق الذي سيحوّل إليه العملاء.",
  "commerce.admin.clickPhone": "رقم الهاتف",
  "commerce.admin.clickPhoneHint": "استخدم رقم الهاتف المسجل في كليك.",
  "commerce.admin.clickOwnerName": "اسم صاحب الحساب",
  "commerce.admin.clickOwnerRequired": "اسم صاحب الحساب مطلوب.",
  "commerce.admin.clickAliasRequired": "اسم كليك مطلوب.",
  "commerce.admin.clickPhoneRequired": "رقم هاتف كليك مطلوب.",
  "commerce.admin.clickPhoneInvalid": "أدخل رقم هاتف دولياً صالحاً.",
  "commerce.admin.instructionsRequired": "التعليمات مطلوبة باللغتين.",
  "commerce.admin.settingsSaved": "تم حفظ إعدادات دفع كليك.",
  "commerce.admin.settingsFailed": "تعذّر حفظ إعدادات دفع كليك.",
  "commerce.admin.blacklistMessage": "هل تريد حظر هذا العميل ومنعه من طلبات الدفع عند الاستلام مستقبلاً؟",
  "commerce.admin.removeBlacklistMessage": "هل تريد إزالة هذا العميل من القائمة السوداء والسماح بالدفع عند الاستلام؟",
  "commerce.admin.riskUpdated": "تم تحديث حالة العميل في القائمة السوداء.",
  "commerce.admin.riskUpdateFailed": "تعذّر تحديث حالة القائمة السوداء.",
  "commerce.admin.rejectReviewMessage": "هل تريد رفض هذا التقييم؟ لن يظهر بعد ذلك في صفحة المنتج.",
  "commerce.admin.reviewUpdated": "تم تحديث حالة التقييم.",
  "commerce.admin.reviewUpdateFailed": "تعذّر تحديث حالة التقييم.",
  "commerce.admin.adjustConfirmation": "أكد تعديل المخزون. الرقم الموجب يضيف مخزوناً والسالب يسحب منه.",
  "commerce.admin.adjustQuantityRequired": "كمية التعديل مطلوبة.",
  "commerce.admin.inventoryUpdated": "تم تعديل المخزون بنجاح.",
  "commerce.admin.inventoryUpdateFailed": "تعذّر تعديل المخزون.",
  "commerce.admin.orderUpdated": "تم تحديث حالة الطلب.",
  "commerce.admin.orderUpdateFailed": "تعذّر تحديث حالة الطلب.",
  "commerce.admin.paymentUpdated": "تم تحديث حالة الدفع.",
  "commerce.admin.paymentUpdateFailed": "تعذّر تحديث حالة الدفع.",
  "commerce.admin.rejectOrder": "رفض الطلب",
  "commerce.admin.deliveryFeeUpdated": "تم تحديث رسوم التوصيل.",
  "commerce.admin.deliveryFeeUpdateFailed": "تعذّر تحديث رسوم التوصيل.",
  "commerce.admin.deliveryFeeRequired": "رسوم التوصيل مطلوبة.",
  "commerce.admin.deliveryFeeInvalid": "لا يمكن أن تكون رسوم التوصيل سالبة.",
  "sidebar.products.variantAttributes": "خصائص المتغيرات",
  "variantAttributes.title": "خصائص المتغيرات",
  "variantAttributes.subtitle": "أنشئ خصائص وقيماً خاصة بالشركة لاستخدامها في تكوين خيارات المنتجات القابلة للبيع.",
  "variantAttributes.create": "إنشاء خاصية",
  "variantAttributes.edit": "تعديل الخاصية",
  "variantAttributes.search": "البحث في الخصائص",
  "variantAttributes.name": "اسم الخاصية",
  "variantAttributes.nameEn": "اسم الخاصية بالإنجليزية",
  "variantAttributes.nameAr": "اسم الخاصية بالعربية",
  "variantAttributes.kind": "نوع الخاصية",
  "variantAttributes.kindHelp": "نوع اللون يتيح ربط صور المنتج بالألوان. المقاس وأخرى يعملان كخصائص متغيرات عادية.",
  "variantAttributes.kinds.color": "لون",
  "variantAttributes.kinds.size": "مقاس",
  "variantAttributes.kinds.other": "أخرى",
  "variantAttributes.values": "القيم",
  "variantAttributes.manageValues": "إدارة القيم",
  "variantAttributes.valuesFor": "قيم {{name}}",
  "variantAttributes.valueName": "اسم القيمة",
  "variantAttributes.addValue": "إضافة قيمة",
  "variantAttributes.usedBy": "مستخدمة في {{count}} مراجع ضمن الكتالوج",
  "variantAttributes.noValues": "لم تتم إضافة قيم بعد.",
  "variantAttributes.empty": "لا توجد خصائص متغيرات.",
  "variantAttributes.confirmDelete": "هل تريد حذف هذه الخاصية وجميع قيمها غير المستخدمة؟ لا يمكن التراجع عن ذلك.",
  "variantAttributes.errors.nameRequired": "اسم الخاصية بالإنجليزية والعربية مطلوب.",
  "variantAttributes.errors.valueRequired": "اسم القيمة مطلوب.",
  "variantAttributes.errors.duplicateGroup": "توجد خاصية أخرى بهذا الاسم.",
  "variantAttributes.errors.duplicateOption": "هذه القيمة موجودة مسبقاً ضمن الخاصية.",
  "variantAttributes.errors.groupInUse": "هذه الخاصية مستخدمة في منتجات أو صور ولا يمكن حذفها.",
  "variantAttributes.errors.optionInUse": "هذه القيمة مستخدمة في منتجات أو صور ولا يمكن حذفها.",
  "variantAttributes.errors.duplicateColor": "هذا اللون موجود بالفعل. استخدم قيمة اللون الحالية.",
  "variantAttributes.errors.invalidColor": "اختر لوناً صالحاً بصيغة #RRGGBB.",
  "variantAttributes.errors.invalidGroupChange": "أكمل القيم المنظمة المطلوبة قبل تغيير نوع الخاصية.",
  "variantAttributes.valueNameAr": "اسم العرض بالعربية",
  "variantAttributes.colorPresets": "ألوان شائعة",
  "variantAttributes.colorValue": "اللون",
  "variantAttributes.hexValue": "قيمة اللون الأساسية",
  "variantAttributes.sizePresets": "إضافة سريعة لمجموعات المقاسات",
  "variantAttributes.sizeHelp": "استخدم مجموعة جاهزة أو أضف أي صيغة مقاس مخصصة. تبقى القيم قابلة لإعادة الاستخدام وغير مرتبطة بنظام مقاسات واحد.",
  "variantAttributes.sort.default": "الترتيب الافتراضي",
  "variantAttributes.sort.name": "الاسم",
  "variantAttributes.sort.created": "الأحدث",
  "settings.title": "الإعدادات",
  "settings.subtitle": "إدارة تجربة الموقع وإعدادات الشركة.",
  "settings.navigation": "التنقل في الإعدادات",
  "settings.nav.appearance": "المظهر",
  "settings.nav.banners": "اللافتات",
  "settings.nav.commerce": "التجارة",
  "settings.nav.company": "الشركة",
  "settings.ai.title": "مساعد التسوق",
  "settings.ai.subtitle": "فعّل أو أوقف المساعد بشكل مستقل للموقع العام ولوحة الإدارة.",
  "settings.ai.storefront": "الموقع العام",
  "settings.ai.storefrontHint": "عند إيقاف هذا الخيار يختفي المساعد من المتجر وتُرفض محادثات الزوار.",
  "settings.ai.admin": "لوحة الإدارة",
  "settings.ai.adminHint": "عند إيقاف هذا الخيار يختفي مساعد الإدارة من لوحة التحكم وتُرفض محادثات الموظفين.",
  "settings.ai.saved": "تم حفظ إعداد مساعد التسوق.",
  "settings.ai.saveError": "تعذر حفظ إعداد مساعد التسوق.",
  "settings.company.title": "معلومات الشركة",
  "settings.company.subtitle": "إدارة هوية الشركة وبيانات التواصل المستخدمة في لوحة التحكم والموقع.",
  "settings.company.name": "اسم الشركة",
  "settings.company.nameAr": "اسم الشركة بالعربية",
  "settings.company.email": "البريد الإلكتروني",
  "settings.company.phone": "رقم الهاتف",
  "settings.company.address": "العنوان",
  "settings.company.taxNumber": "الرقم الضريبي",
  "settings.company.currency": "رمز العملة",
  "settings.company.sector": "قطاع العمل",
  "settings.company.logo": "شعار الموقع",
  "settings.company.logoHelp": "ارفع الشعار المربع واقصصه، وسيظهر بحجمه الفعلي في شريط تنقل الموقع.",
  "settings.company.logoDrop": "أفلت الشعار هنا",
  "settings.company.logoSize": "PNG أو JPG أو WebP حتى 5 ميجابايت",
  "settings.company.logoCropTitle": "قص شعار الموقع",
  "settings.company.logoCropHint": "ضع الشعار داخل الإطار المربع. سيُحفظ بصيغة PNG وحجم 256 × 256، وتظهر معاينته بالحجم نفسه المستخدم في الموقع 40 × 40.",
  "settings.company.favicon": "أيقونة الموقع",
  "settings.company.faviconHelp": "ارفع الأيقونة الصغيرة التي تظهر في تبويبات المتصفح والإشارات المرجعية.",
  "settings.company.faviconDrop": "أفلت أيقونة PNG هنا",
  "settings.company.faviconSize": "PNG فقط، حتى 512 كيلوبايت",
  "settings.company.faviconCropTitle": "قص أيقونة الموقع",
  "settings.company.faviconCropHint": "ضع الأيقونة داخل الإطار المربع. ستُحفظ بصيغة PNG وبحجم مناسب للمتصفح 64 × 64.",
  "settings.company.required": "هذا الحقل مطلوب.",
  "settings.company.invalidEmail": "أدخل بريداً إلكترونياً صالحاً.",
  "settings.company.saved": "تم تحديث معلومات الشركة.",
  "settings.company.saveError": "تعذّر تحديث معلومات الشركة.",
  "banners.title": "إدارة اللافتات",
  "banners.subtitle": "نشر إعلانات مجدولة باللغتين في صفحات المتجر المحددة.",
  "banners.storefrontAnnouncements": "إعلانات المتجر",
  "banners.create": "إنشاء لافتة",
  "banners.edit": "تعديل اللافتة",
  "banners.titleEn": "العنوان (بالإنجليزية)",
  "banners.titleAr": "العنوان (بالعربية)",
  "banners.badgeEn": "الشارة (بالإنجليزية)",
  "banners.badgeAr": "الشارة (بالعربية)",
  "banners.contentEn": "المحتوى (بالإنجليزية)",
  "banners.contentAr": "المحتوى (بالعربية)",
  "banners.scope": "نطاق الظهور",
  "banners.scope.global": "جميع صفحات المتجر",
  "banners.scope.specific": "صفحات محددة",
  "banners.pages": "صفحات المتجر",
  "banners.active": "مفعّلة",
  "banners.startsAt": "تبدأ في",
  "banners.endsAt": "تنتهي في",
  "banners.schedule": "الجدولة",
  "banners.order": "الترتيب",
  "banners.showCta": "إظهار زر الإجراء",
  "banners.ctaLabelEn": "نص زر الإجراء (بالإنجليزية)",
  "banners.ctaLabelAr": "نص زر الإجراء (بالعربية)",
  "banners.ctaHref": "رابط الإجراء أو مسار داخلي",
  "banners.newTab": "فتح الإجراء في علامة تبويب جديدة",
  "banners.filter.search": "البحث في اللافتات...",
  "banners.filter.active": "تصفية حسب الحالة",
  "banners.filter.scope": "تصفية حسب النطاق",
  "banners.filter.page": "تصفية حسب الصفحة",
  "banners.pages.HOME": "الرئيسية",
  "banners.pages.PRODUCT_LISTING": "قائمة المنتجات",
  "banners.pages.PRODUCT_DETAIL": "تفاصيل المنتج",
  "banners.pages.ABOUT": "من نحن",
  "banners.pages.CONTACT": "اتصل بنا",
  "banners.pages.CART": "السلة",
  "banners.pages.CHECKOUT": "إتمام الطلب",
  "banners.pages.PROFILE": "الملف الشخصي",
  "banners.pages.ORDER_DETAIL": "تفاصيل الطلب",
  "banners.validation.required": "هذا الحقل مطلوب.",
  "banners.validation.pagesRequired": "اختر صفحة متجر واحدة على الأقل.",
  "banners.validation.invalidUrl": "أدخل رابطاً آمناً أو مساراً داخلياً.",
  "banners.validation.endAfterStart": "يجب أن يكون تاريخ الانتهاء بعد تاريخ البدء أو مساوياً له.",
  "banners.empty": "لا توجد لافتات تطابق عوامل التصفية.",
  "banners.created": "تم إنشاء اللافتة.",
  "banners.updated": "تم تحديث اللافتة.",
  "banners.deleted": "تم حذف اللافتة.",
  "banners.saveFailed": "تعذّر حفظ اللافتة.",
  "banners.loadFailed": "تعذّر تحميل اللافتات.",
  "banners.deleteFailed": "تعذّر حذف اللافتة.",
  "banners.reorderFailed": "تعذّر تحديث ترتيب اللافتات.",
  "banners.deleteTitle": "حذف اللافتة",
  "banners.deleteMessage": "هل تريد حذف هذه اللافتة نهائياً؟ لا يمكن التراجع عن ذلك.",
  "banners.moveUp": "نقل لأعلى",
  "banners.moveDown": "نقل لأسفل",
  "websiteUsers.title": "حسابات الموقع",
  "websiteUsers.subtitle": "عرض حسابات العملاء والموظفين ونشاط تسجيل دخولهم إلى المتجر.",
  "websiteUsers.search": "البحث بالاسم أو البريد أو اسم المستخدم...",
  "websiteUsers.allTypes": "جميع أنواع المستخدمين",
  "websiteUsers.allStatuses": "جميع الحالات",
  "websiteUsers.user": "المستخدم",
  "websiteUsers.userType": "نوع المستخدم",
  "websiteUsers.role": "الدور",
  "websiteUsers.status": "الحالة",
  "websiteUsers.lastLogin": "آخر دخول للموقع",
  "websiteUsers.loginCount": "مرات دخول الموقع",
  "websiteUsers.joinedAt": "تاريخ الانضمام",
  "websiteUsers.never": "لم يسجل الدخول",
  "websiteUsers.unnamed": "مستخدم بلا اسم",
  "websiteUsers.empty": "لا يوجد مستخدمون يطابقون عوامل التصفية.",
  "websiteUsers.loadFailed": "تعذّر تحميل مستخدمي الموقع.",
  "websiteUsers.types.public": "عميل",
  "websiteUsers.types.credentialed": "موظف",
  "websiteUsers.types.unassigned": "غير معيّن",
  "websiteUsers.statuses.active": "نشط",
  "websiteUsers.statuses.inactive": "غير نشط",
  "websiteUsers.statuses.pending": "قيد الانتظار",
  "websiteUsers.sort.createdAt": "تاريخ الانضمام",
  "websiteUsers.sort.lastLogin": "آخر دخول للموقع",
  "websiteUsers.sort.loginCount": "عدد مرات دخول الموقع",
  "websiteUsers.sort.email": "البريد الإلكتروني",
  "websiteUsers.verified": "تأكيد الحساب",
  "websiteUsers.verifiedYes": "موثّق",
  "websiteUsers.verifiedNo": "غير موثّق",
  "websiteUsers.verifiedAt": "تاريخ التوثيق",
  "websiteUsers.allVerification": "جميع حالات التوثيق",
  "websiteUsers.detailsTitle": "تفاصيل مستخدم الموقع",
  "websiteUsers.notFound": "تعذّر العثور على مستخدم الموقع.",
  "websiteUsers.phone": "الهاتف",
  "websiteUsers.cart": "السلة الحالية",
  "websiteUsers.cartEmpty": "لم يضف هذا المستخدم أي منتجات إلى السلة.",
  "websiteUsers.cartPreparing": "{{count}} منتج في السلة — يستعد للشراء.",
  "websiteUsers.orders": "الطلبات",
  "websiteUsers.ordersEmpty": "لا توجد طلبات لهذا المستخدم بعد.",
  "common.reset": "إعادة تعيين",
  "common.all": "الكل",
  "admin.copilot.title": "مساعد الإدارة",
  "admin.copilot.subtitle": "اسأل عن بيانات متجرك. الإجابات تلتزم بصلاحياتك.",
  "admin.copilot.placeholder": "اسأل عن المبيعات أو المنتجات أو الموظفين أو الاستفسارات…",
  "admin.copilot.send": "إرسال",
  "admin.copilot.open": "فتح مساعد الإدارة",
  "admin.copilot.close": "إغلاق مساعد الإدارة",
  "admin.copilot.newChat": "محادثة جديدة",
  "admin.copilot.history": "المحادثات",
  "admin.copilot.emptyHistory": "ستظهر محادثات الإدارة السابقة هنا.",
  "admin.copilot.untitled": "محادثة جديدة",
  "admin.copilot.deleteChat": "حذف المحادثة",
  "admin.copilot.deleteChatConfirm": "سيتم حذف المحادثة نهائيًا ولا يمكن التراجع.",
  "admin.copilot.historyReadOnlyHint": "المحادثات السابقة للعرض فقط.",
  "admin.copilot.historyReadOnlyTitle": "هذه المحادثة للعرض فقط",
  "admin.copilot.historyReadOnly": "لا يمكنك الإرسال في المحادثات السابقة. ابدأ محادثة جديدة للمتابعة.",
  "admin.copilot.emptyTitle": "كيف أساعدك في إدارة المتجر؟",
  "admin.copilot.empty": "اسأل عن الأكثر مبيعًا أو نقص بيانات المنتجات أو الأرباح أو الموظفين أو استفسارات العملاء.",
  "admin.copilot.thinking": "جارٍ التفكير…",
  "admin.copilot.error": "المساعد غير متاح حاليًا.",
  "admin.copilot.error.FORBIDDEN": "ليست لديك صلاحية هذا الطلب.",
  "admin.copilot.error.NOT_FOUND": "لم يتم العثور على هذه المحادثة.",
  "admin.copilot.error.NETWORK": "تعذّر الوصول إلى مساعد الإدارة. حاول مرة أخرى.",
  "admin.copilot.error.UNKNOWN": "المساعد غير متاح حاليًا."
}
